<template>
  <div class="animated fadeIn">
    <b-breadcrumb><strong>Style List</strong></b-breadcrumb>

    <b-row>
      <!----- SideBar All Design List ---->
      <!-- <sidebarSettingsComponent></sidebarSettingsComponent> -->
      <!----- SideBar All Design List End ---->

      <div class="design-container-details__main">
        <div class="col-md-12 ">
          <!-- code for table -->

          <b-row>
            <b-col md="12">
              <b-card-body>
                <div class="row mt-4"></div>
                
                <div id="typelist">
                  <b-row class="col-md-12 typelist1">
                    <b-col sm="3">
                      <label>Sub Category</label>
                      <b-form-group>
                        <b-form-select
                          v-model="selected_subcat_id"
                          id="selected_subcat_id"
                          name="selected_subcat_id"
                          @change="
                            changesubcat(selected_subcat_id);
                            subcatsearch(selected_subcat_id);
                          "
                        >
                          <option :value="selected">--Select--</option>
                          <option
                            v-for="subcat_details in sub_cat_id_arr"
                            :value="subcat_details.sub_catid"
                            :key="subcat_details.sub_catid"
                            >{{ subcat_details.sub_cattitle }}</option
                          >
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="3">
                      <label>Utility Type</label><br />
                      <b-form-group>
                        <b-form-select
                          v-model="selected_utility_id"
                          id="selected_utility_id"
                          name="selected_utility_id"
                          @change="utilitysearch(selected_utility_id)"
                        >
                          <option :value="selected">--Select--</option>
                          <option
                            v-for="utilitylist in utility_type_arr"
                            :value="utilitylist.utility_id"
                            :key="utilitylist.utility_id"
                            >{{ utilitylist.utilitytype_title }}</option
                          >
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="3">
                      <label>PO Type</label><br />
                      <b-form-group>
                        <b-form-select
                          v-model="selected_po_id"
                          id="selected_po_id"
                          name="selected_po_id"
                          @change="posearch(selected_po_id)"
                        >
                          <option :value="selected">--Select--</option>
                          <option
                            :value="polist.po_id"
                            v-for="polist in po_typearr"
                            :key="polist.po_id"
                            >{{ polist.potype_title }}</option
                          >
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="3">
                      <label>Search</label><br />
                      <b-form-group>
                        <b-input-group>
                          <b-form-input
                            type="text"
                            v-model="search_item"
                            name="first name"
                            class="form-control"
                            placeholder="Search"
                            aria-label="Search"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-button
                              type="submit"
                              variant="primary"
                              @click="getdesignheadstyledetails()"
                              ><i class="fa fa-search" aria-hidden="true"
                                >&nbsp;&nbsp;<b></b></i
                            ></b-button>
                            <button
                              class="btn btn-sm btn-primary ml-4"
                              v-on:click="refresh()"
                              type="button"
                            >
                              <i class="fa fa-refresh"></i>
                            </button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
                <!-- <b-row class="col-md-12 lgtypelist">
                  <b-col sm="3">
                    <label>Sub Category</label>
                    <b-form-group>
                      <b-form-select
                        v-model="selected_subcat_id"
                        id="selected_subcat_id"
                        name="selected_subcat_id"
                        @change="
                          changesubcat(selected_subcat_id);
                          subcatsearch(selected_subcat_id);
                        "
                      >
                        <option :value="selected">--Select--</option>
                        <option
                          :value="subcat_details.sub_catid"
                          v-for="subcat_details in sub_cat_id_arr"
                          :key="subcat_details.sub_catid"
                          >{{ subcat_details.sub_cattitle }}</option
                        >
                      </b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <label>PO Type</label><br />
                    <b-form-group>
                      <b-form-select
                        v-model="selected_po_id"
                        id="selected_po_id"
                        name="selected_po_id"
                        @change="posearch(selected_po_id)"
                      >
                        <option :value="selected">--Select--</option>
                        <option
                          :value="polist.po_id"
                          v-for="polist in po_typearr"
                          :key="polist.po_id"
                          >{{ polist.potype_title }}</option
                        >
                      </b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <label>Utility Type</label><br />
                    <b-form-group>
                      <b-form-select
                        v-model="selected_utility_id"
                        id="selected_utility_id"
                        name="selected_utility_id"
                        @change="utilitysearch(selected_utility_id)"
                      >
                        <option :value="selected">--Select--</option>
                        <option
                          :value="utilitylist.utility_id"
                          v-for="utilitylist in utility_type_arr"
                          :key="utilitylist.utility_id"
                          >{{ utilitylist.utilitytype_title }}</option
                        >
                      </b-form-select>
                    </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <label>Search</label><br />
                    <b-form-group>
                      <b-input-group>
                        <b-form-input
                          type="text"
                          v-model="search_item"
                          name="first name"
                          class="form-control"
                          placeholder="Search"
                          aria-label="Search"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-button
                            type="submit"
                            variant="primary"
                            @click="getdesignheadstyledetails()"
                            ><i class="fa fa-search" aria-hidden="true"
                              >&nbsp;&nbsp;<b></b></i
                          ></b-button>
                          <button
                            class="btn btn-sm btn-primary ml-4"
                            v-on:click="refresh()"
                            type="button"
                          >
                            <i class="fa fa-refresh"></i>
                          </button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row> -->
                <!-- {{segmentList_arr}} -->
                <b-row class="col-md-12 lgtypelist">


                  <div class="col mx-1" >

                    <b-input-group class="mt-2">          
                      <ejs-multiselect
                        id="selected_segment_id"
                        placeholder="Select Segment"
                        v-model="selected_segment_id"
                        name="selected_segment_id"
                        :fields="segementid_fields"
                        :dataSource="segmentList_arr"
                        :showSelectAll="true"
                        :class="{ input: true }"
                      >
                      </ejs-multiselect>
                    </b-input-group>

                  </div>
                 
                 <!-- <div class="col mx-1" v-if="user_type!='Admin'" >
                   <label>Gender</label>
                     <b-form-group>
                       <b-form-select @change="showCollection(brand_id, selected_segment_id)"
                         v-model="selected_segment_id"
                         id="selected_segment_id"
                         name="selected_segment_id"
                         placement="Select Gender"
                       >
                         <option :value="null">--Select Gender--</option>
                         <option v-if="user_type!='Admin'" v-for="segmentlist in segmentarray_list" :value="segmentlist.segment_id" :key="segmentlist.segment_id">{{
                           segmentlist.segment_title
                         }}</option>
                         <option v-if="user_type=='Admin'" v-for="segmentlist in segmentarray_list" :value="segmentlist.segment_id" :key="segmentlist.segment_id">{{
                          segmentlist.seg_name
                        }}</option> 
                       </b-form-select>
                     </b-form-group>
                 </div>  -->

                 <!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
                 <div class="col mx-1">
                  <b-input-group class="mt-2">
                                
                    <ejs-multiselect
                      id="selected_collection_id"
                      placeholder="Select Season"
                      v-model="selected_collection_id"
                      name="selected_collection_id"
                      :fields="collectionid_fields"
                      :dataSource="collectionData"
                      :showSelectAll="true"
                      :class="{ input: true }"
                    >
                    </ejs-multiselect>
                  </b-input-group>

                 </div>
                 <!-- <div class="col mx-1" v-if="user_type!='Admin'">
                   <label>Season</label>
                    <b-form-group >
                       <b-form-select @change="showSubcategory(selected_collection_id)"
                         v-model="selected_collection_id"
                         id="selected_collection_id"
                         name="selected_collection_id"
                       >
                         <option :value="null">--Select Season--</option>
                         <option v-for="collection in collectionData" :value="collection.collection_id" :key="collection.collection_id">{{
                           collection.collection_title
                         }}</option>
                       </b-form-select>
                     </b-form-group>
                 </div>  -->


                 <!-- ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
                 <div class="col mx-1" >

                  <b-input-group class="mt-2">
                                
                    <ejs-multiselect
                      id="sub_catid"
                      placeholder="Select Sub-Category"
                      v-model="sub_catid"
                      name="sub_catid"
                      :fields="subcatid_fields"
                      :dataSource="sub_cat_id_arr"
                      :showSelectAll="true"
                      :class="{ input: true }"
                    >
                    </ejs-multiselect>
                  </b-input-group>

                 </div>

                 <!-- <div class="col mx-1" v-if="user_type!='Admin'">
     
                   <label>Sub-category</label>
                      <b-form-group >
                       <b-form-select @change="getPoTypeList(sub_catid);"
                         v-model="sub_catid"
                         id="sub_catid"
                         name="sub_catid"
                       >
                         <option :value="null">--Select Sub-category--</option>
                         <option v-for="subcatarry in sub_cat_id_arr" :value="subcatarry.sub_catid" :key="subcatarry.sub_catid">{{
                           subcatarry.sub_cattitle
                         }}</option>
                       </b-form-select>
                     </b-form-group>
                 </div> -->


                 <!--~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~  -->

                 <div class="col mx-1">
                    <b-input-group class="mt-2">
                                  
                      <ejs-multiselect
                        id="selected_po_id"
                        placeholder="Select PO Id"
                        v-model="selected_po_id"
                        name="selected_po_id"
                        :fields="poid_fields"
                        :dataSource="po_typearr"
                        :showSelectAll="true"
                        :class="{ input: true }"
                      >
                      </ejs-multiselect>
                    </b-input-group>

                  </div>

                  <!-- <div class="col mx-1" v-if="user_type!='Admin'">
                   <label>PO Type (PT)</label>
                     <b-form-group >
                     {{po_typearr}}
                       <b-form-select
                         v-model="selected_po_id"
                         id="selected_po_id"
                         name="selected_po_id"
                       >
                         <option :value="null">--Select PO Type--</option>
                         <option v-for="polist in po_typearr" :value="polist.po_id" :key="polist.po_id">{{
                           polist.potype_title
                         }}</option>
                       </b-form-select>
                     </b-form-group>
                 </div>  -->


      
               </b-row> 
               <b-row class="col-md-12 lgtypelist mt-2">
                <div class="col-3 mx-1">
                    <b-input-group class="mt-2">
                      <b-form-input
                        type="text"
                        v-model="search_style_code"
                        name="search_style_code"
                        class="form-control"
                        placeholder="Style Code (comma separated)"
                        aria-label="Style Code"
                      ></b-form-input>
                    </b-input-group>
                  </div>

                  <div class="col-3">
                    <b-input-group class="mt-2">
                      <b-form-input
                        type="text"
                        v-model="search_design_title"
                        name="search_design_title"
                        class="form-control"
                        placeholder="Design Title (comma separated)"
                        aria-label="Design Title"
                      ></b-form-input>
                    </b-input-group>
                  </div>

                  <div class="col">
                     <b-button @click="searchData(brand_id)"
                           type="submit"
                           variant="primary"
                           class="px-4 pull-left mt-2"
                           >Search</b-button
                         >
                      <button
                         class="btn btn-sm btn-primary ml-3 mt-2 px-3 pb-2"
                         v-on:click="refresh()"
                         type="button"
                       >
                         <i class="fa fa-refresh"></i>
                       </button>
                  </div>

                 
                 <!-- <div class="col mx-1">
                   <label></label>
                   <b-form-group>
                    <b-button @click="searchData(brand_id)"
                           type="submit"
                           variant="primary"
                           class="px-4 pull-left"
                           >Search</b-button
                         >
                       <button
                         class="btn btn-sm btn-primary ml-3 px-3 pb-2"
                         v-on:click="refresh()"
                         type="button"
                       >
                         <i class="fa fa-refresh"></i>
                       </button>
                     </b-form-group>
                 </div>  -->
               </b-row>
                <b-row class="col-md-12 ">
                  <!--  <input type="hidden" name="isactiveId" id="isactiveId" value="">
                  <input type="hidden" name="brand_title" id="brand_title" value="">
                    <b-col md="4" class="my-1">
                      <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                        <b-input-group>
                          <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                          <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col> -->
                  <!-- <b-col md="4" class="my-1">
                      <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
                        <b-input-group>
                          <b-form-select v-model="sortBy" :options="sortOptions">
                            <option slot="first" :value="null">-none-</option>
                          </b-form-select>
                          <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
                            <option :value="false">Asc</option> <option :value="true">Desc</option>
                          </b-form-select>
                        </b-input-group>
                      </b-form-group>
                    </b-col>  -->
                  <!--  <b-col md="4" class="my-1">
                      <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
                        <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                      </b-form-group>
                    </b-col>   -->
                </b-row>

                <!--  <b-col md="12">
               
            </b-col> -->

                <b-col sm="12" class="text-right">
                  <button
                    id="button-1"
                    type="button"
                    class="btn btn-default btntypelist"
                    @click="styledropdown"
                    style="color: #1b8eb7;font-size: 20px;float:left"
                  >
                    <i class="fa fa-filter" aria-hidden="true"></i>
                  </button>
                  <p>
                    <b style="margin-right:5%"
                      >Total Records :<span style="color:red;">{{
                        list_totalRows
                      }}</span></b
                    >
                   
                  </p>
                
                    <b-button v-if="$route.path.includes('/style_list/PO') &&
                    user_type != 'Brand_Designer' &&
                    user_type != 'Quality_Controller' &&
                    user_type != 'Quality_Executive' &&
                   (user_type == 'Buyer'|| user_type=='Junior Buyer'|| user_type== 'PO Executive')
                " @click="DownloadExcel" class="mb-2">Download PO sheet</b-button>
                </b-col>
                <b-tooltip target="button-1" title="Apply Filter"></b-tooltip>
                <!-- v-if="route_id=='ALL_Designs'" -->
                <b-col sm="12" class="text-right">
                  <router-link
                    class="px-4 pull-right"
                    :to="{
                      name: 'designsummry',
                      params: { id: route_status + ',' + selected_brand_id+ ',' + selected_brand_type },
                    }"
                  >
                    <b-button
                      type="submit"
                      variant="primary"
                      class="px-4 pull-right"
                      >View Thumbnails</b-button
                    >
                  </router-link>

                  <b-button
                  v-if="$route.path.includes('/style_list/PO') &&
                    user_type != 'Brand_Designer' &&
                    user_type != 'Quality_Controller' &&
                    user_type != 'Quality_Executive' 
                    &&
                    (user_type == 'Buyer' || user_type == 'Junior Buyer' || user_type== 'PO Executive')
                  "
                  size="sm"
                  variant="success"
                  class="ml-2"
                  @click="$bvModal.show('upload-po-sheet-modal')"
                >
                  Upload PO Sheet
                </b-button>
                </b-col>
                <b-col
                  sm="12"
                  class="text-right"
                  v-if="
                    (user_type === 'Admin') &&
                      route_status === 'Designs_Pending_For_Approval'
                  "
                >
                  <b-button
                    type="button"
                    variant="info"
                    class="px-4 pull-right"
                    @click="approveDesign('rejected')"
                    v-bind:disabled="
                      this.selectedDesign.length > 0 ? false : true
                    "
                    >Add to Reject</b-button
                  >
                  <b-button
                    type="button"
                    variant="info"
                    class="px-4 mr-2 pull-right"
                    @click="bulkapproveselectgrade()"
                    v-bind:disabled="
                      this.selectedDesign.length > 0 ? false : true
                    "
                    >Add to Approve</b-button
                  >
                </b-col>
                <!-- {{items[0].design_status}} -->
                <b-col  v-if="( user_type === 'Admin' && items.length > 0 && items && items[0].design_status=='Approval-pending' && items[0].operational_status == 'BH-approved') || (user_type === 'Brand_Manager' && items.length > 0 && items && items[0].design_status=='Approval-pending' && items[0].operational_status == 'DH-approved') || ( user_type === 'Design_Head' && items.length > 0 && items && items[0].design_status=='Approval-pending' && items[0].operational_status == 'StyleNoCreated') ">
                <b-button
                    type="button"
                    variant="info"
                    class="px-4 mr-2 pull-right"
                    @click="$refs.fileInput.click()"
                  >
                    <i class="fa fa-upload"></i>
                  </b-button>
                  <input
                    type="file"
                    ref="fileInput"
                    accept=".xlsx"
                    style="display: none"
                     @change="selectFile($event)"
                  />

                </b-col>
                <b-col v-if="(user_type === 'Admin' && items.length > 0  && items && items[0].design_status=='Approval-pending' && items[0].operational_status == 'BH-approved') || ( user_type === 'Brand_Manager' &&  items.length > 0 && items && items[0].design_status=='Approval-pending' && items[0].operational_status == 'DH-approved') || ( user_type === 'Design_Head' && items.length > 0 && items && items[0].design_status=='Approval-pending' && items[0].operational_status == 'StyleNoCreated')  ">
                 <b-button
                  type="button"
                  variant="info"
                  class="px-4 mr-2 pull-right"
                  @click="downloadstyledata()">
                  Download Style Data
                </b-button>
                </b-col>
              
                <br /><br />
                <p style="display:none;">{{items}}</p>
                <div class="col-md-12 ipad">
                  <b-table
                    class="mt-4"
                    caption-top
                    show-empty
                    stacked="md"
                    :busy="isBusy"
                    :items="items"
                    :fields="fields1"
                    :current-page="currentPage"
                    :perPage="perPage"
                    :bordered="bordered"
                    :filter="filter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    @filtered="onFiltered"
                  >
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                    <!-- Check all -->

                    <template
                      slot="table-caption"
                      slot-scope="row"
                      v-if="
                        (user_type === 'Admin') &&
                          route_status === 'Designs_Pending_For_Approval'
                      "
                    >
                      <input 
                        type="checkbox"
                        id="checkAll"
                        @click="(e) => allDesignSeleted(e.target.checked)"
                      />
                      Check all
                    </template>
                    <template slot="styleimage" slot-scope="row">
                      <div class="text-center">
                        <img
                          v-if="row.item.vendor_sample_image"
                          :src="row.item.vendor_sample_image"
                          alt="Style Image"
                          style="width:80px;height:80px;object-fit:contain;"
                        />
                        <span v-else> <img
                          v-if="row.item.style_image"
                          :src="row.item.style_image"
                          alt="Style Image"
                          style="width:100px;height:100px;object-fit:contain;"
                        /></span>
                      </div>
                    </template>

                     <!-- Check all ends-->


                    <!-- <template slot="style_image" slot-scope="row"> -->
                    <!-- <img v-bind:src="style_image" style="height:220px width:270px padding:5px;" alt="This image is not available" > -->
                    <!-- <div style="height:220px width:270px padding:5px;"> -->
                    <!-- <img v-bind:src="img_path"/> -->
                    <!-- <img v-bind:src="img_path" alt="No Image To Show" height="220" width="270" style="padding:5px;"/> -->
                    <!-- </div> -->
                    <!-- <div>
                         <b-img v-bind:src="style_details.style_image" ></b-img></div> -->
                    <!-- <img :src="style_image" />  -->
                    <!-- </template> -->

                    <!-- <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;"/> -->


                      <!--Individula chekc-  -->

                    <template slot="designtitle" slot-scope="row">

                      <p>{{row.item.design_title}} <i class="fa fa-check bg-success" v-if="row.item.assigned_to != null" data-toggle="tooltip" data-placement="right" title="Style Assigned"></i></p>
                    </template>
                    <template
                      slot="select"
                      slot-scope="row"
                      v-if="
                        (user_type === 'Admin') &&
                          route_status === 'Designs_Pending_For_Approval'
                      "
                    >
                      <input
                        type="checkbox"
                        v-if="isAllDesignSelected === false"
                        :checked="isDesignSelected(row.item.style_id)"
                        @change="
                          (e) =>
                            setSelectedDesign(
                              e.target.checked,
                              row.item.style_id
                            )
                        "
                        :key="row.item.style_id + 1"
                        :id="row.item.style_id+'------'+ 1"
                      />
                      <input
                        type="checkbox"
                        v-if="isAllDesignSelected === true"
                        v-model="isAllDesignSelected"
                        :key="row.item.style_id + 2"
                        :id="row.item.style_id +'------'+ 2"
                        @change="(e)=>handleAlterCheckComponent(e.target.checked,row.item.style_id)"
                      />
                    </template>

                     <!--Individula chekc- ends -->

                    <template slot="actions" slot-scope="row">
                      <i
                        @click="editinfoModal(row.item)"
                        data-toggle="tooltip"
                        title="Update Vendor Details"
                        class="fa fa-pencil-square-o"
                        aria-hidden="true"
                        style=" color: green;"
                        >&nbsp;&nbsp;&nbsp;&nbsp;
                        <!-- <i class="fa fa-edit"></i> -->
                      </i>
                      <i
                        v-on:click="deleteinfoModal(row.item)"
                        data-toggle="tooltip"
                        title="Delete Vendor Details"
                        class="fa fa-trash"
                        aria-hidden="true"
                        style="color: red"
                      >
                        <!-- <i class="fa fa-trash" aria-hidden="true" style="color: red"></i> -->
                      </i>
                    </template>
                    <template slot="action" slot-scope="row">
                      <!-- <button type="button" class="btn btn-info" style="width: 110px;" @click="opendesignModal(row.item)">Info</button> -->
                      <b-col md="12" class="pull-right text-right">
                        <!-- <div class="pull-right"> -->
                        <b-dropdown
                          variant="link"
                          toggle-class="text-decoration-none"
                          no-caret
                        >
                          <template v-slot:button-content>
                            <button
                              @click="getrowdata(row.item)"
                              style="border: none;"
                              class="btn btn-link"
                            >
                              <span
                                class="cui-options icons font-1xl d-block"
                                style="font-size: 15px;"
                              ></span>
                            </button>
                          </template>
                          <b-dropdown-item>
                            <button
                              v-b-modal.modal-lg
                              type="button"
                              class="btn btn-link"
                              @click="opendesignModal(row.item)"
                              v-if="
                                user_type == 'Design_Head' ||
                                  user_type == 'Admin' ||
                                  user_type == 'Quality_Head' 
                              "
                            >
                              <i
                                class="fa fa-address-card-o"
                                variant="primary"
                                aria-hidden="true"
                                style="color: green; margin-left: 5px;"
                              ></i
                              >Style Details
                            </button>
                            <router-link
                              :to="'/design_details/' + route_id"
                              v-if="
                                user_type == 'Brand_Manager' ||
                                  user_type == 'Fit_Technician' ||
                                  user_type == 'Buyer' ||
                                  user_type == 'Brand_Designer' ||
                                  user_type == 'Quality_Controller' ||
                                  user_type == 'Quality_Executive' ||
                                  user_type == 'PO Executive' ||
                                  user_type == 'Junior_Buyer' ||
                                  user_type == 'Buying_Head'
                              "
                            >
                              <b-button type="submit" variant="primary"
                                ><i
                                  class="fa fa-address-card-o"
                                  variant="primary"
                                  aria-hidden="true"
                                  style="color: green; margin-left: 5px;"
                                ></i
                                >Style Details</b-button
                              >
                            </router-link>
                          </b-dropdown-item>

                           <b-dropdown-item v-if="(row.item.operational_status == 'Buyer-approved' || row.item.operational_status == 'TP-Uploaded' || row.item.operational_status == 'Measurement Chart-Uploaded' || row.item.operational_status == 'BOM-Updated') && user_type == 'Buyer' && row.item.assigned_to == null ">
                          
                              <b-button type="submit" variant="primary" @click="assignStyle(row.item.style_id,row.item.style_code)"
                                ><i
                                  class="fa fa-address-card-o"
                                  variant="primary"
                                  aria-hidden="true"
                                  style="color: green; margin-left: 5px;"
                                ></i
                                >Assign Style</b-button
                              >
                            
                          </b-dropdown-item> 
                          
                        </b-dropdown>
                        <!-- </div> -->
                      </b-col>
                    </template>

                    <template slot="vendor_sample_image" slot-scope="row">
                      <div class="text-center">
                        <img
                          v-if="
                            row.item.sample_image !== null ||
                              row.item.sample_image !== ''
                          "
                          :src="row.item.sample_image"
                          style="width:80px;height:80px;"
                        />
                        <p
                          v-if="
                            row.item.sample_image === '' ||
                              row.item.sample_image === null
                          "
                        >
                          NA
                        </p>
                      </div>
                    </template>
                  </b-table>
                </div>
                <b-col md="6" class="my-1">
                  <!-- <b-pagination
                    v-model="currentPage"
                    :total-rows="list_totalRows"
                    :per-page="perPage"
                    class="my-0"
                  ></b-pagination> -->
                  <paginate v-if="this.items.length != 0"
                    :page-count="noofpages"
                    :page-range="10"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  >
                  </paginate>
                </b-col>
                <!-- Info modal -->
                <!-- </div> -->
              </b-card-body>
            </b-col>
          </b-row>

          
          <!-- code for table ends -->
          <!-- Dropdown Modal for small -->

          <!-- Code For Design Details Model -->
          <b-modal
            id="modal-lg"
            size="xl"
            title="Design Details"
            v-model="showdesigndetails"
            @ok="showdesigndetails = false"
          >
            <b-row>
              <b-col sm="12">
                <button
                  style="color: #1b8eb7;font-size: 12px;float:right"
                  class="btn btn-default tablechart"
                  @click="opentable"
                >
                  <i
                    v-b-tooltip.hover
                    title="Measurement Chart"
                    class="fa fa-table"
                    aria-hidden="true"
                  ></i>
                </button>
              </b-col>

              <b-col sm="12" class="col-md-12">
                <b-form
                  name="addSegmentForm"
                  @submit.prevent="updatestylestatus(comment, status)"
                >
                  <!-- <b-row class="col-md-12">
            
          </b-row> -->
                  <b-row class="col-md-12">
                    <b-col cols="4">
                      <div
                        class="detailimgborder"
                        style="width:307px !important;"
                        v-if="style_details.style_image_type == 'image'"
                      >
                        <a :href="style_details.style_image" download>
                          <img
                            style=" width: 290px !important; height: 290px !important;"
                            v-bind:src="img_path"
                            alt="No Image To Show"
                            class="detailsmodalimg"
                          />
                        </a>

                        <button
                          v-b-modal.modal-lg
                          type="button"
                          class="btn btn-success summaryzoombtn"
                        >
                          <i class="fa fa-search-plus" aria-hidden="true"
                            >&nbsp;Zoom Image</i
                          >
                        </button>
                        <!-- <image-magnifier :src="img_path"
                      :zoom-src="img_path"
                      width="400"
                      height="300"
                      zoom-width="400"
                      zoom-height="300" style="padding:5px;"></image-magnifier> -->
                        <!-- <b-form-group style="margin-top:25px;">
                          
                      <b-form-group>
                          <b-col md="9">
                          </b-col>
                        <b-col md="3" class="pull-right"><img v-bind:src="img_path" height="100px" width="100px" /></b-col></b-form-group>
                      
                    </b-form-group>     -->
                      </div>
                      <div v-if="style_details.style_image_type == 'other'">
                        <div id="pdfOverride">
                          <vue-pdf-embed :source="style_details.style_image" />
                        </div>

                        <div
                          style="display: flex; justify-content: center; align-items: center;"
                        >
                          <button
                            v-b-modal.modal-lg
                            type="button"
                            class="btn btn-success summaryzoombtn"
                          >
                            <i class="fa fa-search-plus" aria-hidden="true"
                              >&nbsp;Zoom Image</i
                            >
                          </button>
                        </div>
                      </div>

                      <div
                        class="divdesign mt-2"
                        v-if="
                          style_details.artwork_image != null &&
                            style_details.artwork_image != ''
                        "
                      >
                        <p style="text-align:center" class="mt-2">
                          Artwork Image
                        </p>
                        <img
                          v-bind:src="style_details.artwork_image"
                          class="imgdesign"
                        />
                        <p class="text-center">
                          {{ style_details.artwork_title }}
                        </p>
                        <button
                          type="button"
                          @click="openArtWorkimage"
                          class="btn btn-success btndesign mb-2"
                        >
                          <i class="fa fa-search-plus" aria-hidden="true"
                            >&nbsp;Zoom Image</i
                          >
                        </button>
                      </div>
                    </b-col>

                    <b-col cols="2"></b-col>

                    <b-col cols="6" class="designsummaryipad">
                      <div class="col-md-12 designsummary">
                        <!-- <b-col md="6" class="pull-left"> -->
                        <b-form-group class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Brand Title</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ customer.brand_title }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Style Code</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.style_code }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Story Name</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.story_name }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Category Title</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.category_title }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Segment Title</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.segment_title }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Collection Title</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ customer.collection_title }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Sub Category Title</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.sub_cattitle }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Style Name</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.style_name }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0"
                          v-if="
                            style_details.artwork_created_by != null &&
                              style_details.artwork_created_by != ''
                          "
                        >
                          <b-col md="5" class="pull-left">
                            <label for="name"><b>Artwork Created By</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left colonb"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right titleb"
                            >{{ style_details.artwork_created_by }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0"
                          v-if="
                            style_details.artwork_edited_by != null &&
                              style_details.artwork_edited_by != ''
                          "
                        >
                          <b-col md="5" class="pull-left">
                            <label for="name"><b>Artwork Edited By</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left colonb"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right titleb"
                            >{{ style_details.artwork_edited_by }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Design Hit</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.design_hit }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="styleform m-0">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Style Type</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.style_type }}
                          </b-col>
                        </b-form-group>
                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Upper Material</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.upper_material }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Inner Lining</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.inner_lining }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Sole</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.sole }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Surface Ornamentation</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.surface_ornamentation }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Highlight</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.highlight }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid === 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Fastening Type</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.fastening_type }}
                          </b-col>
                        </b-form-group>


                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid !== 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Fabric Typeeee</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.fabrictype }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid !== 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"
                              ><b>Top Fabric/Upper Fabric</b></label
                            >
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.materialinfoupperfabric }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid !== 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"
                              ><b>Bottom Fabric/Sole Material</b></label
                            >
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.solematerial }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid !== 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Fabric Composition</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.fabriccomposition }}
                          </b-col>
                        </b-form-group>

                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid !== 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Sleeve Length</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right detailscol6"
                            >{{ style_details.sleevelength }}
                          </b-col>
                        </b-form-group>

                        <!-- {{style_details.sample_image}} -->
                        <b-form-group class="m-0"
                          v-if="
                            style_details.sample_image != null &&
                              style_details.sample_image != ''
                          "
                        >
                          <b-col md="5" class="pull-left">
                            <label for="name"><b>Sample Image</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left colonb"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right titleb">
                            <a
                              :href="style_details.sample_image"
                              target="_blank"
                              ><i
                                class="fa fa-download"
                                aria-hidden="true"
                                v-b-tooltip.hover
                                title="Click to download"
                                style="font-size:20px;"
                              ></i
                            ></a>
                          </b-col>
                        </b-form-group>

                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>PO Type</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.potype_title }}
                          </b-col>
                        </b-form-group>
                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Utility Type</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.utilitytype_title }}
                          </b-col>
                        </b-form-group>
                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>No of Size Sets</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.no_of_sizeset }}
                          </b-col>
                        </b-form-group>
                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Panton Type</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.panton_type }}
                          </b-col>
                        </b-form-group>

                        <b-form-group v-if="user_type != 'Admin'" class="mt-1">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Color</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel">
                            <div class="mt-1" v-for="colors in selected_mutlicolor" :style="`background-color:${colors.split(' ').pop()}`">
                              {{ colors }}
                          </div>
                          </b-col>
                        </b-form-group>
                        <!-- <b-form-group v-if="selected_panton_type != 'OTHERS'" class="m-0">
                          <b-col md="5" class="pull-left">
                            <label for="name"><b>Selected Color</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left colonb"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel">
                            <div id="showcolor" class="selectedcolor"></div>
                          </b-col>
                        </b-form-group> -->

                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Operational Status</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.operational_status }}
                          </b-col>
                        </b-form-group>

                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Design Status</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.design_status }}
                          </b-col>
                        </b-form-group>

                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Created By</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.full_name }}
                          </b-col>
                        </b-form-group>

                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Designer Name</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.designer_name }}
                          </b-col>
                        </b-form-group>

                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Fit Tech Name</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.fit_tech_name }}
                          </b-col>
                        </b-form-group>

                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"
                              ><b>Buyer Name / BM Name</b></label
                            >
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col
                            md="6"
                            class="pull-right titleb"
                            v-if="this.style_details.sendqname === null"
                            >{{ style_details.buyer_name }}
                          </b-col>
                          <b-col
                            md="6"
                            class="pull-right titleb"
                            v-if="this.style_details.sendqname != null"
                            >{{ style_details.sendqname }}
                          </b-col>
                        </b-form-group>

                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Created Date</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.created_date }}
                          </b-col>
                        </b-form-group>

                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Updated Date</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.updated_date }}
                          </b-col>
                        </b-form-group>

                        <b-form-group v-if="user_type != 'Admin'" class="m-0">
                          <b-col md="5" class="pull-left designsummarycol5">
                            <label for="name"><b>Style Description</b></label>
                          </b-col>
                          <b-col md="1" class="pull-left designsummarycol1"
                            ><b>:</b></b-col
                          >

                          <b-col md="6" class="pull-right summarymodel"
                            >{{ style_details.style_description }}
                          </b-col>
                        </b-form-group>
                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid !== 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Material: </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>
        
                          <b-col md="6" class="pull-right detailscol6"
                            ><span v-if="style_details.material">{{style_details.material}}</span>
                            <span v-if="!style_details.material">NA</span>
                          </b-col>
                        </b-form-group>
                        <b-form-group class="styleform m-0" v-if = "selected_sub_catid !== 170">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Pack Of: </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>
        
                          <b-col md="6" class="pull-right detailscol6"
                            ><span v-if="style_details.pack_of">{{style_details.pack_of}}</span>
                            <span v-if="!style_details.pack_of">NA</span>
                          </b-col>
                        </b-form-group>
                        <b-form-group class="styleform m-0">
                          <b-col md="5" class="pull-left detailscol5">
                            <label for="name"><b>Epp: </b></label>
                          </b-col>
                          <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>
        
                          <b-col md="6" class="pull-right detailscol6"
                            ><span v-if="style_details.is_epp">{{style_details.is_epp}}</span>
                            <span v-if="!style_details.is_epp">NA</span>
                          </b-col>
                        </b-form-group>

                         <b-form-group class="styleform m-0">
                            <b-col md="5" class="pull-left detailscol5">
                                <label for="name"><b>Style Comment </b></label>
                            </b-col>
                            <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                            <b-col md="6" class="pull-right detailscol6"
                                ><span v-if="style_details.style_comment">{{style_details.style_comment}}</span>
                                <span v-if="!style_details.style_comment">NA</span>
                            </b-col>
        
                        </b-form-group>

                          <b-form-group class="styleform m-0">
                            <b-col md="5" class="pull-left detailscol5">
                              <label for="name"><b>Download PDF File </b></label>
                            </b-col>
                            <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                            <b-col md="6" class="pull-right detailscol6"
                              ><a :href="style_details.pdf_file" target="_blank" v-if="style_details.pdf_file"><i class="fa fa-download" style="font-size:x-large"></i></a>
                              <span v-if="!style_details.pdf_file">NA</span>
                            </b-col>
                          </b-form-group>

                          <b-form-group class="styleform m-0">
                            <b-col md="5" class="pull-left detailscol5">
                              <label for="name"><b>Design Head Grade </b></label>
                            </b-col>
                            <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                            <b-col md="6" class="pull-right detailscol6"
                              ><span v-if="style_details.dh_grade">{{style_details.dh_grade}}</span>
                              <span v-if="!style_details.dh_grade">NA</span>
                            </b-col>
            
                            
                          </b-form-group>
                          <b-form-group class="styleform m-0">
                            <b-col md="5" class="pull-left detailscol5">
                              <label for="name"><b>Brand Manager Grade </b></label>
                            </b-col>
                            <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                            <b-col md="6" class="pull-right detailscol6"
                              ><span v-if="style_details.bm_grade">{{style_details.bm_grade}}</span>
                              <span v-if="!style_details.bm_grade">NA</span>
                            </b-col>
                          </b-form-group>

                          <!-- <b-form-group class="styleform m-0">
                            <b-col md="5" class="pull-left detailscol5">
                              <label for="name"><b>Buying Head Grade </b></label>
                            </b-col>
                            <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                            <b-col md="6" class="pull-right detailscol6"
                              ><span v-if="style_details.buyinghead_grade">{{style_details.buyinghead_grade}}</span>
                              <span v-if="!style_details.buyinghead_grade">NA</span>
                            </b-col>
                          </b-form-group> -->
                          <b-form-group class="styleform m-0" v-if="style_details.buyer_grade">
                            <b-col md="5" class="pull-left detailscol5">
                              <label for="name"><b>Buyer Grade </b></label>
                            </b-col>
                            <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                            <b-col md="6" class="pull-right detailscol6"
                              ><span v-if="style_details.buyer_grade">{{style_details.buyer_grade}}</span>
                              <span v-if="!style_details.buyer_grade">NA</span>
                            </b-col>
                          </b-form-group>

                          <b-form-group class="styleform m-0" v-if="style_details.final_grade">
                            <b-col md="5" class="pull-left detailscol5">
                              <label for="name"><b>Final Grade / Fashion Head Grade </b></label>
                            </b-col>
                            <b-col md="1" class="pull-left detailscol1"><b>:</b></b-col>

                            <b-col md="6" class="pull-right detailscol6"
                              ><span v-if="style_details.final_grade">{{style_details.final_grade}}</span>
                              <span v-if="!style_details.final_grade">NA</span>
                            </b-col>
                          </b-form-group>
                          
                      </div>
                    </b-col>

                    <b-col cols="6">
                      <!-- <div style="float: left;
                    border: 1px solid lightgray;"> -->
                      <!-- Added Code for Size Set -->
                      <div
                        class="col-md-12 summarytableset"
                        id="sizesetData"
                        v-if="user_type != 'Admin'"
                      ></div>

                      <!-- Added Code for Size Set Ends -->
                      <!-- </div> -->
                    </b-col>

                    <!-- <b-col cols="2"></b-col> -->

                    <b-col cols="6" class="designsummaryipad">
                      <div class="col-md-12 designsummary">
                        
                        
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <div class="col-md-12 tablemd" id="tablesm">
                      <!-- <b-row> -->
                      <b-form>
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <td scope="col" style="width: 10%">Size Set</td>
                              <td scope="col" style="width: 20%">Unit</td>
                              <td scope="col" style="width: 15%">Age From</td>
                              <td scope="col" style="width: 15%">Age To</td>
                              <td
                                scope="col"
                                v-if="
                                  selected_status_code_number >= 12 &&
                                    selected_status_code_number != 13
                                "
                                style="width: 17%"
                              >
                                Factory Size(In CM / In Inch)
                              </td>
                              <td
                                scope="col"
                                v-if="selected_status_code_number >= 15"
                                style="width: 17%"
                              >
                                Quantity
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(tbl_invoice_product, index) in sizeset">
                              <td><label>Size &nbsp;</label>{{ index + 1 }}</td>

                              <td>
                                <b-form-select
                                  :plain="true"
                                  name="tbl_selected_month"
                                  required
                                  v-model="tbl_selected_month[index]"
                                  :options="unit_arr"
                                  disabled
                                  readonly
                                >
                                </b-form-select>
                              </td>

                              <td>
                                <b-form-select
                                  :plain="true"
                                  name="tbl_selectedfromage"
                                  v-model="tbl_selectedfromage[index]"
                                  required
                                  :options="month_arr"
                                  disabled
                                  readonly
                                >
                                </b-form-select>
                              </td>

                              <td>
                                <b-form-select
                                  :plain="true"
                                  v-model="tbl_selectedtoage[index]"
                                  :options="to_month_arr"
                                  required
                                  disabled
                                  readonly
                                >
                                </b-form-select>
                              </td>

                              <td
                                v-if="
                                  selected_status_code_number >= 12 &&
                                    selected_status_code_number != 13
                                "
                              >
                                <b-form-input
                                  type="text"
                                  name="tbl_factorysize"
                                  v-model="tbl_factorysize[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>

                              <td v-if="selected_status_code_number >= 15">
                                <b-form-input
                                  type="text"
                                  name="tbl_quantity"
                                  v-model="tbl_quantity[index]"
                                  :key="index"
                                  required
                                  disabled
                                  readonly
                                ></b-form-input>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </b-form>
                      <!-- </b-row> -->
                    </div>
                  </b-row>

                  <!-- {{style_details.operational_status}}  -->
                  <!-- {{style_details.operational_status}} -->

                  <!-- </div> -->

                  <div
                    slot="footer"
                    style="margin-top:20px;text-align:right"
                    v-if="
                      (style_details.operational_status == 'StyleNoCreated' ||
                        style_details.operational_status == 'BH-approved') &&
                        user_type != 'Buyer'
                    "
                  >
                    <b-form-group label="Remark" :label-cols="3">
                      <b-form-textarea
                        rows="3"
                        max-rows="6"
                        v-model="comment"
                        type="text"
                        name="comment"
                        placeholder="Enter Comment Here..."
                      >
                      </b-form-textarea
                      ><br />
                      <b-input-group class="mb-3">
                        <label class="radio-inline"
                          ><input
                            type="radio"
                            name="optradio"
                            value="approved"
                            v-model="status"
                            @click="selectGrade()"
                            checked
                          />&nbsp;Approved</label
                        >&nbsp;&nbsp;
                        <label class="radio-inline"
                          ><input
                            type="radio"
                            name="optradio"
                            value="rejected"
                            v-model="status"
                          />&nbsp;Reject</label
                        >&nbsp;&nbsp;

                        <label class="radio-inline"
                          ><input
                            type="radio"
                            name="optradio"
                            value="Feedback"
                            v-model="status"
                          />&nbsp;Feedback</label
                        >
                        &nbsp;&nbsp;
                      </b-input-group>
                    </b-form-group>
                    <div slot="footer" class="text-right">
                      <b-button
                        type="submit"
                        size="sm"
                        class="mr-4"
                        variant="primary"
                      >
                        Update Status</b-button
                      >
                      <b-button
                        size="sm"
                        variant="danger"
                        @click="commentcancel()"
                        >cancel</b-button
                      >
                    </div>
                  </div>
                </b-form>
              </b-col>
            </b-row>
          </b-modal>
          <!-- Code For Design Details Ends -->
          <b-modal
            size="xl"
            title="Table Set"
            v-model="opentablemodel"
            @ok="opentablemodel = false"
          >
            <template slot="modal-header">
              <h5>Measurement Chart</h5>
            </template>
            <!-- <template slot="default" slot-scope="{ hide }">
              <div>
                Hiiiiiiiiii
              </div>
            </template> -->
            <!-- <b-button  size="sm"  @click="openimagecancel()" style="background: none; border: none;"><i class="fa fa-close"></i></b-button>
            </template> -->
            <template slot="default">
              <!--    <div>
                <span style="color:red;padding:10px"><b>N.B&nbsp;:</b>&nbsp;M- Month & Y- Year</span>
              </div> -->
              <b-row style="overflow:auto">
                <b-form>
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <td scope="col" class="sumtdhset">Size Set</td>
                        <td scope="col" class="sumtdhunit">Unit</td>
                        <td scope="col" class="sumtdhagefrom">Age From</td>
                        <td scope="col" class="sumtdhageto">Age To</td>
                        <td
                          scope="col"
                          class="sumtdhsize"
                          v-if="
                            selected_status_code_number >= 12 &&
                              selected_status_code_number != 13
                          "
                          style="width: 17%"
                        >
                          Factory Size(In CM / In Inch)
                        </td>
                        <td
                          scope="col"
                          class="sumtdhquantity"
                          v-if="selected_status_code_number >= 15"
                          style="width: 17%"
                        >
                          Quantity
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(tbl_invoice_product, index) in sizeset">
                        <td>
                          <label class="sumtdbset">Size &nbsp;</label
                          >{{ index + 1 }}
                        </td>

                        <td>
                          <b-form-select
                            class="sumtdbunit"
                            :plain="true"
                            name="tbl_selected_month"
                            required
                            v-model="tbl_selected_month[index]"
                            :options="unit_arr"
                            disabled
                            readonly
                          >
                          </b-form-select>
                        </td>

                        <td>
                          <b-form-select
                            class="sumtdbfage"
                            :plain="true"
                            name="tbl_selectedfromage"
                            v-model="tbl_selectedfromage[index]"
                            required
                            :options="month_arr"
                            disabled
                            readonly
                          >
                          </b-form-select>
                        </td>

                        <td>
                          <b-form-select
                            class="sumtdbtage"
                            :plain="true"
                            v-model="tbl_selectedtoage[index]"
                            :options="to_month_arr"
                            required
                            disabled
                            readonly
                          >
                          </b-form-select>
                        </td>

                        <td
                          v-if="
                            selected_status_code_number >= 12 &&
                              selected_status_code_number != 13
                          "
                        >
                          <b-form-input
                            type="text"
                            class="sumtdbsize"
                            name="tbl_factorysize"
                            v-model="tbl_factorysize[index]"
                            :key="index"
                            required
                            disabled
                            readonly
                          ></b-form-input>
                        </td>

                        <td v-if="selected_status_code_number >= 15">
                          <b-form-input
                            type="text"
                            class="sumtdbquantity"
                            name="tbl_quantity"
                            v-model="tbl_quantity[index]"
                            :key="index"
                            required
                            disabled
                            readonly
                          ></b-form-input>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-form>
              </b-row>
              <div slot="footer" class="text-right">
                <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                <b-button size="sm" variant="danger" @click="opentablecancel()"
                  >cancel</b-button
                >
              </div>
            </template>

            <template slot="modal-footer" slot-scope="{ hide }">
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
            </template>
          </b-modal>
          <!-- Image Zoom Model -->
          <b-modal
            id="modal-lg"
            size="lg"
            title="Image Zoom"
            v-model="openimagemodel"
            @ok="openimagemodel = false"
          >
            <template slot="modal-header">
              <h5>Zoom Image</h5>
              <!-- <button type="button" class="close" aria-label="Close"  slot-scope="{ hide }">
              <span aria-hidden="true">&times;</span>
            </button> -->
              <b-button
                size="sm"
                @click="openimagecancel()"
                style="background: none; border: none;"
                ><i class="fa fa-close"></i
              ></b-button>
            </template>
            <template slot="default" slot-scope="{ hide }">
              <div id="btn_navbar">
                <button type="button" class="btn btn-success" @click="zoomin()">
                  <i class="fa fa-search-plus" aria-hidden="true"
                    >&nbsp;Zoom In</i
                  ></button
                >&nbsp;
                <button type="button" class="btn btn-danger" @click="zoomout()">
                  <i class="fa fa-search-minus" aria-hidden="true"
                    >&nbsp;Zoom Out</i
                  >
                </button>
                <button
                  type="button"
                  class="btn btn-info m-2"
                  @click="showMagnifier()"
                >
                  <i class="fa fa-search" aria-hidden="true"
                    >&nbsp;Magnifier Glass</i
                  >
                </button>
              </div>

              <div class="main1" style="text-align: center;">
                <!-- <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;" /> -->
                <div
                  v-if="style_details.style_image_type == 'image'"
                  class="img-magnifier-container"
                  style="padding:2px;"
                >
                  <img
                    v-bind:src="style_details.style_image"
                    id="map"
                    style="padding:5px;width:100%;height:100%;"
                  />
                </div>
                <div v-if="style_details.style_image_type == 'other'">
                  <vue-pdf-embed
                    :source="style_details.style_image"
                    id="map"
                    height="220"
                    width="270"
                    style="padding:5px;"
                  />
                </div>
              </div>

              <div slot="footer" class="text-right">
                <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                <b-button size="sm" variant="danger" @click="openimagecancel()"
                  >cancel</b-button
                >
              </div>
            </template>
            <template slot="modal-footer" slot-scope="{ hide }">
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
            </template>
          </b-modal>
          <!-- Image Zoom Model -->

          <!-- Art work Image Zoom Model -->
          <b-modal
            id="modal1-lg"
            size="lg"
            title="Image Zoom"
            v-model="openartworkimagemodel"
            @ok="openartworkimagemodel = false"
          >
            <template slot="modal-header">
              <h5>Zoom Image</h5>
              <b-button
                size="sm"
                @click="openartworkimagecancel()"
                style="background: none; border: none;"
                ><i class="fa fa-close"></i
              ></b-button>
            </template>
            <template slot="default" slot-scope="{ hide }">
              <div id="btn_navbar">
                <button type="button" class="btn btn-success" @click="zoomin()">
                  <i class="fa fa-search-plus" aria-hidden="true"
                    >&nbsp;Zoom In</i
                  ></button
                >&nbsp;
                <button type="button" class="btn btn-danger" @click="zoomout()">
                  <i class="fa fa-search-minus" aria-hidden="true"
                    >&nbsp;Zoom Out</i
                  >
                </button>
                <button
                  type="button"
                  class="btn btn-info m-2"
                  @click="showMagnifier()"
                >
                  <i class="fa fa-search" aria-hidden="true"
                    >&nbsp;Magnifier Glass</i
                  >
                </button>
              </div>

              <div class="main1" style="text-align: center;">
                <!-- <img v-bind:src="style_details.style_image" id="map" height="220" width="270" style="padding:5px;"/> -->

                <img
                  v-bind:src="style_details.artwork_image"
                  id="map"
                  style="padding:5px;width:100%;height:100%;"
                />
              </div>

              <div slot="footer" class="text-right">
                <!--  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button> -->
                <b-button
                  size="sm"
                  variant="danger"
                  @click="openartworkimagecancel()"
                  >cancel</b-button
                >
              </div>
            </template>
            <template slot="modal-footer" slot-scope="{ hide }">
              <b-button size="sm" style="display:none">
                Cancel
              </b-button>
            </template>
          </b-modal>
          <!-- Art work Image Zoom Model -->
          <!-- Modal for assigning style to junior buyer -->
          <b-modal id="modal-1" title="Assign style to junior buyer"  v-model="showAssignStyleModal"
              @ok="showAssignStyleModal = false">

            <b-form @submit.prevent="validatesubmitAssignForm(formData)">

              <div class="row">
                <div class="col-11 m-2 ">
                  <label>Style Code</label>
                  <input type="text" class="form-control" v-model="selected_styleCode" disabled />
                </div>
                 <div class="col-11 m-2">
                   <label>Select Junior Buyer</label>
                   <b-form-select name="buyername" id="buyername" v-model="buyername"
                        
                      >
                        <!-- <option :value="null">--Select--</option> -->
                        <option placeholder="Select option"
                            v-for="buyerarr in buyer_list_arr"
                            :value="buyerarr.user_id"
                            :key="buyerarr.user_id"
                            >{{ buyerarr.full_name }}</option
                          >
                      </b-form-select>
                       
                </div>
              </div>

              <div class="mt-5">
                <b-button size="sm"  class="float-right btn btn-danger ml-2 mr-2" @click="cloaseAssignStyleModal" >
                  Cancel
                </b-button> 
                <b-button size="sm" type="submit" class="float-right btn btn-success" >
                  Submit
                </b-button>
              </div>
          
            </b-form>
            
          </b-modal>

            <!-- Grading Modal -->
          <b-modal id="showGradeModal" size="md" title="Select grade for the style" v-model="showGradeModal" @ok="showGradeModal = false">
            <b-form
            name="addSegmentForm"
             @submit.prevent="validategrade()">

            <b-col sm="12">
                <label for="grade">Select Grade</label>
                <b-form-group>
                <b-form-select required
                    v-model="selected_Grade"
                    id="selected_Grade"
                    name="selected_Grade">
                    <option :value="null">--Select--</option>
                    <option value="A+" >A+</option>
                    <option value="A" >A</option>
                    <option value="B+" >B+</option>
                    <option value="B" >B</option>
                    <option value="C+" >C+</option>
                    <option value="C" >C</option>
                    <option value="D" >D</option>

                </b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="5" style="float:right">
                <b-button type="submit" variant="primary">Submit</b-button> &nbsp;
                <b-button type="button" variant="danger" @click="cancelshowGradeModal()">Cancel</b-button>
            </b-col> 

            </b-form>   
          </b-modal>

          <!-- grading modal for buld approve -->
            <b-modal id="showGradeModalbulkapprove" size="md" title="Select grade for the style" v-model="showGradeModalbulkapprove" @ok="showGradeModalbulkapprove = false">
            <b-form
            name="addSegmentForm"
             @submit.prevent="validategradegrade()">

            <b-col sm="12">
                <label for="grade">Select Grade</label>
                <b-form-group>
                <b-form-select required
                    v-model="selected_Grade"
                    id="selected_Grade"
                    name="selected_Grade">
                    <option :value="null">--Select--</option>
                    <option value="A+" >A+</option>
                    <option value="A" >A</option>
                    <option value="B+" >B+</option>
                    <option value="B" >B</option>
                    <option value="C+" >C+</option>
                    <option value="C" >C</option>
                    <option value="D" >D</option>

                </b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="5" style="float:right">
                <b-button type="submit" variant="primary">Submit</b-button> &nbsp;
                <b-button type="button" variant="danger" @click="cancelshowGradeModal()">Cancel</b-button>
            </b-col> 

            </b-form>   
          </b-modal>

          <!-- Upload PO Sheet Modal -->
          <b-modal
            id="upload-po-sheet-modal"
            title="Upload PO Sheet"
            hide-footer
            @hidden="onUploadModalHidden"
          >
            <div class="d-flex flex-column">
              <div class="mb-3">
                <label><b>Select Excel file</b></label>
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  @change="handleUploadFileChange($event)"
                  class="form-control-file"
                />
                <small v-if="uploadFile" class="text-muted">
                  Selected: {{ uploadFile.name }}
                </small>
              </div>

              <div class="d-flex justify-content-end">
                <b-button
                  size="sm"
                  variant="secondary"
                  class="mr-2"
                  @click="$bvModal.hide('upload-po-sheet-modal')"
                >
                  Cancel
                </b-button>

                <b-button
                 
                  variant="success"
                  :disabled="!uploadFile"
                  @click="uploadSelectedFile"
                >
                  <i class="fa fa-upload"></i>&nbsp;Upload
                </b-button>
              </div>

              <div class="mt-3">
                <small class="text-muted">
                  Only Excel files (.xlsx / .xls) are supported.  
                </small>
              </div>
            </div>
          </b-modal>

        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import CONSTANTS from "@/utils/constants";
import auth from "@/utils/auth";
import Vue from "vue";
import ImageMagnifier from "vue-image-magnifier";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

Vue.use(ImageMagnifier);

import sidebarSettingsComponent from "./_sidebarSettingsComponent.vue";

const axios = require("axios");
export default {
  name: "Tabs",
  components: {
    sidebarSettingsComponent,
    VuePdfEmbed,
  },
  data() {
    return {
      isBusy: false,
      sampelAddModal: false,
      customer: {},
      addAgentMaster: false,
      editAgentMaster: false,
      bordered: true,
      showSideMenu: true,
      items: [],
      result: [],
      value: [],
      sortDesc: true,
      sortDirection: "desc",
      user_type: "",
      progress: 0, // Add progress property for file uploads
      selectedFiles: null, // For file uploads
      imgname: "", // For file name
      fields1: [
        // { key: 'brand_title', label: 'Brand Title', sortable: true, sortDirection: 'desc' },
        // { key: 'segment_title', label: 'Segment Title', sortable: true},
        //  { key: 'collection_title', label: 'Collection Title', sortable: true},
        { key: "select", label: "Select", class: "design" },
        { key: "designtitle", label: "Design Name", class: "design" },

        { key: "sub_cattitle", label: "Subcat Title", class: "design" },
        { key: "potype_title", label: "PO Type", class: "design" },
        { key: "designer_name", label: "Designer Name", class: "design" },
        // { key: "vendor_sample_image", label: "Sample Image", class: "design" },
        { key: 'styleimage', label: 'Style Image'},
        { key: "operational_status", label: "Status", class: "design" },
        { key: "comments", label: "Remark", class: "design" },
        { key: "action", label: "Action", class: "design" },
      ],

      // for multiple approve/reject
      selectedDesign: [],
      isAllDesignSelected: false,
      openartworkimagemodel: false,

      // opendropdownmodel: false,
      showdesigndetails: false,
      currentPage: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: true,
      sortDirection: "desc",
      filter: null,
      totalRows: 0,
      list_totalRows: 0,
      selected_style_id: 0,
      style_details: [],
      color_family: [],
      img_path: "",
      status: "",
      comment: "",
      selected: "",
      style_name_arr: [],
      brand_title_arr: [],
      segment_title_arr: [],
      collection_title_arr: [],
      brand_title: "",
      showfeedbackmodel: false,
      feedback: "",
      route_id: 0,
      opentablemodel: false,
      openimagemodel: false,
      style_image: "",
      po_typearr: [],
      selected_po_id: 0,
      utility_type_arr: [],
      sub_cat_id_arr: [],
      selected_subcat_id: 0,
      sub_cat: 0,
      selected_po_id: 0,
      selected_utility_id: 0,
      selected_collection_id: 0,
      selected_segment_id: 0,
      route_id: "",
      search_item: "",
      //  sub_cat_id_arr: [],
      selected: "",
      search_subcat: 0,
      search_utility: 0,
      search_po: 0,
      search_style_code: "",
      search_design_title: "",
      sizeset: [],
      invoice_products: [
        {
          unit: [],
          selectedfromage: [],
          selectedtoage: [],
          quantity: [],
          factorysize: [],
        },
      ],
      selected_month: [],
      selected_age: 0,
      selectedfromage: [],
      selectedtoage: [],
      quantity: [],
      factorysize: [],
      unit_arr: [
        { value: "0", text: "Month" },
        { value: "1", text: "Year" },
      ],
      month_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
        { value: "21", text: "21" },
        { value: "22", text: "22" },
        { value: "23", text: "23" },
        { value: "24", text: "24" },
      ],
      year_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
      ],
      to_month_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
        { value: "13", text: "13" },
        { value: "14", text: "14" },
        { value: "15", text: "15" },
        { value: "16", text: "16" },
        { value: "17", text: "17" },
        { value: "18", text: "18" },
        { value: "19", text: "19" },
        { value: "20", text: "20" },
        { value: "21", text: "21" },
        { value: "22", text: "22" },
        { value: "23", text: "23" },
        { value: "24", text: "24" },
      ],
      to_year_arr: [
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
        { value: "9", text: "9" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
      ],
      tbl_selected_month: [],
      tbl_selectedfromage: [],
      tbl_selectedtoage: [],
      tbl_invoice_products: [
        {
          tbl_unit: [],
          tbl_selectedfromage: [],
          tbl_selectedtoage: [],
          tbl_factorysize: [],
          tbl_quantity: [],
        },
      ],

      tbl_unit: [],
      tbl_selectedfromage: [],
      tbl_selectedtoage: [],
      tbl_factorysize: [],
      tbl_quantity: [],
      selected_status_code_number: 0,
      access_token: "",
      info_length: 0,
      selected_id: "",
      route_status: "",
      selected_brand_id: 0,
      pageNo: 1,
      noofpages: "",
      pageOptions: [5, 10, 15],
      sortBy: true,
      selected_color_family: "",
      selected_pantone_no: "",
      selected_panton_type: "",
      showhexcolor: "",
      colortype: {},
      customer: {},
      colorcode: {},
      color_name: [],
      color_family: [],
      pantoncolor: [],
      showhexcolor: "",
      pantonno_result: [],
      errors: [],
      showcolorname: "",
      SelectPantonType: "",
      checkAll: false,
      body1:{},

      // FOr muilticolor show
      selected_mutlicolor:[],
      Obj2:{},
      Obj3:{},
      Obj4:{},
      styleArr:[],
      Object1:{},
      showAssignStyleModal: false,
      selected_styleid:'',
      selected_styleCode:'',

      buyer_list_arr:[],
      buyername:'',

      // Search Data
      segmentarray_list: [],
      selected_segment_id: null,
      collectionData: [],
      collection_brand_id: "",
      collection_segment_id: "",
      selected_collection_id: null,
      brand_id: '',
      segment_id: '',
      segmentList_arr: [],
      totalRows: 0,
      sub_catid: "",
      sub_cat_id_arr: [],
      po_typearr: [],
      sub_catid: null,
      selected_po_id: null,
      result:[],
      designerName:"",
    // For grading system
      showGradeModal: false,
      showGradeModalbulkapprove: false,
      selected_Grade:null,
      selected_brand_type:'',
      segementid_fields: { text: "text", value: "value" },
      collectionid_fields:  { text: "text", value: "value" },
      subcatid_fields: { text: "text", value: "value" },
      poid_fields:  { text: "text", value: "value" },
      Objectdata:{},
      downloadAllStyledata: false,
      dataitem: [],
      selectedFiles:"",
      imgname:"",
      uploadFile: null
    };
  },
  created: function() {
    this.route_id = this.$route.params.id;
   
    const myArr = this.route_id.split(",");
    // const mysubcatArr = this.route_id;
    this.route_status = myArr[0];
    this.selected_brand_id = myArr[1];
    console.log("this.selected_brand_id", this.selected_brand_id);
    this.selected_brand_type = myArr[2];
    console.log(" this.selected_brand_type",  this.selected_brand_type);
    // router.beforeEach((to, from, next) => {
  // const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
//   //to.matched.some(record => record.meta.requiresAuth) && 
  if (!localStorage.userData) {
    // localStorage.setItem('redirectUrl', to.fullPath);
    //     // next({ name: 'login' });
    localStorage.redirectUrl = window.location.href;
    // window.location.href = window.location.origin + '/login';
    window.location.href = window.location.origin + '/cams_login';
   } 
// else {
//     next();
//   }
// });
    var userData = localStorage.getItem("userData");
    var userInfo = JSON.parse(userData);
  //  this.brand_id= userInfo[0].user_type=='Admin' ? (userInfo[userInfo.length-1].brand_id ? userInfo[userInfo.length-1].brand_id : null) : userInfo[0].brand_assign
  //  if(userInfo[0].user_type=='Admin'){
    this.brand_id= userInfo[0].user_type=='Admin' ? (userInfo[userInfo.length-1].brand_id ? userInfo[userInfo.length-1].brand_id : null) : userInfo[0].brand_assign
    this.showCollection(this.brand_id)
    this.showSubcategory(this.selected_collection_id,userInfo[0].user_id)
    this.getPoTypeList(this.sub_catid,userInfo[0].user_id)
  //  }

   
   
   // this.getBrandSegmentList();
    // console.log("userData",userData)
    this.access_token = userInfo[0]["token"];
    axios.defaults.headers.common["x-access-token"] = this.access_token;
    axios.defaults.headers.common["Content-Type"] =
      "application/json;charset=UTF-8";
    axios.defaults.headers.common["Accept"] = "application/json";
    axios.defaults.headers.common["Origin"] = "http://localhost:8080";
    this.user_email = userInfo[0].email_id;
    this.user_type = userInfo[0].user_type;
    //this.sub_cat_id_arr = userInfo[0].subcat_assign;
    
    if(myArr[1] && myArr[1] != 'undefined'){
      localStorage.setItem('brand_id',myArr[1])
    }

    
    // console.log("TTT", this.selected_brand_id);
    // this.getdesignheadstyledetails(this.pageNo);
    // if (this.user_type == "Admin") {
    //   this.getSubCategoryList();
    // }
    // return false;
    //this.getdesigndetail();
  },
  computed: {
    
    sortOptions() {
      // Create an options list from our fields
      return this.fields1
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  mounted() {
    var userData = localStorage.getItem('userData');
    var userInfo = JSON.parse(userData)
    this.getBrandSegmentList();
    let tempLocalStorage = localStorage.filters ? JSON.parse(localStorage.filters) : null
    if(tempLocalStorage){
      if(tempLocalStorage.selected_segment_id){
        this.selected_segment_id = tempLocalStorage.selected_segment_id
        if(this.user_type=='Admin'){
          this.showCollection((userInfo[userInfo.length-1].brand_id ? userInfo[userInfo.length-1].brand_id : null),tempLocalStorage.selected_segment_id)
        }else{
          this.showCollection(userInfo[0].brand_assign,tempLocalStorage.selected_segment_id)
        }
        this.selected_collection_id = tempLocalStorage.selected_collection_id
        if(tempLocalStorage.selected_collection_id){
          this.showSubcategory(tempLocalStorage.selected_collection_id)
        }
        this.sub_catid = tempLocalStorage.sub_catid
        if(tempLocalStorage.sub_catid){
          this.getPoTypeList(tempLocalStorage.sub_catid)
        }
        this.selected_po_id = tempLocalStorage.selected_po_id
      }
      
    }
    this.getdesignheadstyledetails(this.pageNo);
  },
  methods: {
    closefeedback: function() {
      this.showfeedbackmodel = !this.showfeedbackmodel;
    },
    getrowdata(value) {
      this.route_id = value.style_id;
    },
    // refresh: function() {
    //   this.selected_subcat_id = "";
    //   this.selected_utility_id = "";
    //   this.selected_po_id = "";
    //   this.search_item = "";
    //   this.search_po = 0;
    //   this.search_utility = 0;
    //   this.search_subcat = 0;
    //   // this.search_item=0;
    //   this.getdesignheadstyledetails(this.pageNo);
    // },

    openArtWorkimage: function() {
      this.openartworkimagemodel = !this.openartworkimagemodel;
    },

    openartworkimagecancel: function() {
      this.openartworkimagemodel = !this.openartworkimagemodel;
    },

    // Search function api's

    searchData:function(brand_id){
      this.updateFilters();
      this.getdesignheadstyledetails();
      //this.displayDashboardData(brand_id);
    },

        /****** Function to Get Brand & Segments ********/
        getBrandSegmentList:function(){
      // document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      if (userData) {
        var userInfo = JSON.parse(userData);
        this.user_id = userInfo[0].user_id;
        this.brand_assign = userInfo[0].brand_assign;
        if (userInfo[0].user_type == "Brand_Manager") {
          this.selected_brand_manager = userInfo[0].user_id;
        } else {
          this.selected_brand_manager = userInfo[0].brand_manager;
        }
        var obj = {}
        if(userInfo[0].user_type == 'Admin'){
          obj = {brand_id: userInfo[userInfo.length-1].brand_id ? userInfo[userInfo.length-1].brand_id : this.selected_brand_id}
        }else{
          obj = {
            user_id: this.user_id,
            selected_brand: userInfo[0].brand_assign,
            brand_manager: this.selected_brand_manager,
          }
        }
        axios
          .post(`${CONSTANTS.API_URL+'/'+(userInfo[0].user_type == 'Admin' ? 'getBrandSegmentListForAdminAndVendor' : 'getBrandSegmentList')}`, obj)
          .then((response) => {
           
            this.result = response.data;
            if (this.result.returnmsg === "Successful") { 
              // if(userInfo[0].user_type == 'Admin'){
                // this.segmentList_arr = this.result.returnvalue
              
                // if(this.user_type == 'Admin'){
                    let tempsegement_list =[]
                    
                    if(userInfo[0].user_type == 'Admin'){
                      response.data.returnvalue.map((item, index) => {
                        let tempobj ={}
                        tempobj.text = item.segment_title
                        tempobj.value = item.segment_title
                        tempsegement_list.push(tempobj)

                      })

                    }
                    else{
                      this.result.returnvalue[0]['segment_list'].map((item, index) => {
                        let tempobj ={}
                        tempobj.text = item.segment_title
                        tempobj.value = item.segment_title
                        tempsegement_list.push(tempobj)

                      })
                    }

                    this.segmentList_arr = tempsegement_list
                // }
                // else{
                //   this.segmentarray_list =this.result.returnvalue
                // }
                this.totalRows = this.result.returnvalue.length
              // }
              // else {
                // document.getElementById("overlay").style.display = "none";
                // this.segmentarray_list = this.result.returnvalue[0]['segment_list'];
                // this.segmentList_arr = this.result.returnvalue;
                // this.totalRows = this.segmentList_arr[0]["segment_list"].length;

                // if (this.totalRows > 0) {
                //   this.segment_id = this.segmentList_arr[0]["segment_list"][0][
                //     "segment_id"
                //   ];
                //   this.brand_id = this.segmentList_arr[0]["segment_list"][0][
                //     "brand_id"
                //   ];
                //   //this.showCollection(this.brand_id, this.segment_id);
                // }
              // }
            }
            else{
              this.segmentList_arr = [];
              this.totalRows = 0;
            }
          })
           .catch((e) => {
            // this.errors.push(e);
            console.log('getBrandSegmentList error------>',e)
          });

      }
    },

        // Collection list accorfing to segment selected
    showCollection(brand_id, segment_id) {
      // alert(this.selected_brand_id)
      this.selected_collection_id=null,
      this.sub_catid=null,
      this.selected_po_id=null,
      this.sub_cat_id_arr = [];
      this.po_typearr = [];


      // document.getElementById("overlay").style.display = "block";
      this.collection_brand_id = brand_id;
      this.collection_segment_id = segment_id;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      // var user_id = userInfo[0].user_id;

      const Obj = {
        brand_id: userInfo[0].brand_assign,
        segment_id: segment_id,
        user_id: userInfo[0].user_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getSegmentCollectionList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          if (response.data.returnmsg == "Successful") {

            //  if(this.user_type == 'Admin'){/
                let tempcollction_list =[]
                  response.data.returnvalue.collections.map((item, index) => {
                    let tempobj ={}
                    tempobj.text = item.collection_title
                    tempobj.value = item.collection_title
                    tempcollction_list.push(tempobj)

                  })
                this.collectionData = tempcollction_list
            //  }
            //  else{
            //    this.collectionData = response.data.returnvalue.collections;
            //  }
             console.log("collections");
             console.log(this.collectionData)
          }else{
            this.collectionData = []
          }
        })
         .catch((e) => {
            this.errors.push(e);
          });
    
    },

        /******Function To Get Sub Category List********/

      // Sub Category list accorfing to segment selected
        showSubcategory(collection_id,user_id) {

         // this.updateFilters(); 
          this.sub_catid = null,
          this.selected_po_id = null,
          this.po_typearr = [];

          // document.getElementById("overlay").style.display = "block";
          const Obj = {
            collection_id:collection_id,
            user_id: user_id ? user_id : userInfo[0].user_id
 ,
          };
          axios
            .post(`${CONSTANTS.API_URL}/getSubcategoryForDashboardFilter`, Obj)
            .then((response) => {
              // document.getElementById("overlay").style.display = "none";
              if (response.data.returnmsg == "Successful") {
               
                // if(this.user_type == 'Admin'){
                    let tempsubcat_list =[]
                    response.data.returnvalue.map((item, index) => {
                      let tempobj ={}
                      tempobj.text = item.sub_cattitle
                      tempobj.value = item.sub_catid
                      tempsubcat_list.push(tempobj)

                    })
                  this.sub_cat_id_arr = tempsubcat_list
                // }
                // else{
                //   this.sub_cat_id_arr = response.data.returnvalue;
                // }
              }else{
                this.sub_cat_id_arr = []
              }
            })
            .catch((e) => {
                this.errors.push(e);
              });
                
        },

        /******Function To Get PO Type List********/
    getPoTypeList: function(subcat_id,user_id) {
      this.selected_po_id=null;

      // document.getElementById("overlay").style.display = "block";

      // this.isBusy = true;
      const Obj = {
        subcat_id,
        user_id: user_id ? user_id : userInfo[0].user_id
      };
      axios
        .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
        .then((response) => {
          // document.getElementById("overlay").style.display = "none";
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            
            // this.totalRows = this.result.returnvalue.length;
            // this.isBusy = !this.isBusy;
            // if(this.user_type == 'Admin'){
              let temppo_list =[]
                response.data.returnvalue.map((item, index) => {
                  let tempobj ={}
                  tempobj.text = item.title
                  tempobj.value = item.po_id
                  temppo_list.push(tempobj)

                })
              this.po_typearr = temppo_list
            // }
            // else{
            //   this.po_typearr = this.result.returnvalue;
            // }
          } else {
            this.po_typearr = [];
            // this.totalRows=0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    updateFilters(){
        
        const filters = {
          "selected_segment_id" : this.selected_segment_id,
          "selected_collection_id" : this.selected_collection_id,
          "sub_catid": this.sub_catid,
          "selected_po_id": this.selected_po_id
        };
        localStorage.setItem('filters',JSON.stringify(filters));
        console.log(filters);
        console.log(this.selected_po_id);
      },

    refresh: function () {
      this.collectionData = [];
      this.sub_cat_id_arr = [];
      this.po_typearr = [];
      
      this.selected_segment_id = null,
        this.selected_collection_id = null,
        this.selected_subcat_id = null,
        this.selected_po_id = null,
        this.search_style_code = "",
        this.search_design_title = "",
        localStorage.removeItem('filters');
        this.getdesignheadstyledetails();
        this.showCollection(this.brand_id)
        this.showSubcategory(this.selected_collection_id)
        this.getPoTypeList(this.sub_catid)
        // this.displayDashboardData();

    },

    /******Function To Get Sub Category List********/
    // getSubCategoryList: function(value) {
    //   this.isBusy = true;
    //   const Obj = {
    //     subcat_id: 26,
    //   };

    //   // axios.post(`${CONSTANTS.API_URL}/getSubCategoryList`, {

    //   // })
    //   axios
    //     .post(`${CONSTANTS.API_URL}/getSubCategoryList`, Obj)
    //     .then((response) => {
    //       //document.getElementById("overlay").style.display = "none";
    //       this.result = response.data;

    //       if (this.result.returnmsg === "Successful") {
    //         this.sub_cat_id_arr = this.result.returnvalue;
    //         this.totalRows = this.result.returnvalue.length;
    //       } else {
    //         this.sub_cat_arr = [];
    //         this.totalRows = 0;
    //       }
    //     })
    //     .catch((e) => {
    //       this.errors.push(e);
    //     });
    // },

    subcatsearch: function(value) {
      // alert(value);
      this.search_subcat = 0;
      this.search_subcat = value;
      this.getdesignheadstyledetails(this.pageNo);
    },
    utilitysearch: function(value) {
      this.search_utility = 0;
      this.search_utility = value;
      this.getdesignheadstyledetails(this.pageNo);
    },
    posearch: function(value) {
      this.search_po = 0;
      this.search_po = value;
      this.getdesignheadstyledetails(this.pageNo);
    },
    clickCallback(pageNo) {
      //   alert(" i m in pagination task");
      // alert(pageNum)
      this.getdesignheadstyledetails(pageNo);
    },

    changesubcat(id) {
      // alert(id);
      this.sub_cat = id;
      this.getUtilityTypeList();
      this.getPoTypeList();
    },

    /******Function To Get Utility Type List********/
    getUtilityTypeList: function() {
      // document.getElementById("overlay").style.display = "block";

      this.isBusy = true;
      const Obj = {
        subcat_id: this.sub_cat,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getUtilityTypeList`, Obj)
        .then((response) => {
          this.result = response.data;

          if (this.result.returnmsg === "Successful") {
            // document.getElementById("overlay").style.display = "none";
            this.utility_type_arr = this.result.returnvalue;
            console.log("this.utility_type_arr", this.utility_type_arr);
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
          } else {
            this.utility_type_arr = [];
            this.totalRows = 0;
            // this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    /******Function To Get Utility Type List Ends********/

    /******Function To Get PO Type List********/
    // getPoTypeList: function() {
    //   // document.getElementById("overlay").style.display = "block";

    //   // this.isBusy = true;
    //   const Obj = {
    //     subcat_id: this.sub_cat,
    //   };
    //   axios
    //     .post(`${CONSTANTS.API_URL}/getPoTypeList`, Obj)
    //     .then((response) => {
    //       // document.getElementById("overlay").style.display = "none";
    //       this.result = response.data;

    //       if (this.result.returnmsg === "Successful") {
    //         this.po_typearr = this.result.returnvalue;
    //         this.totalRows = this.result.returnvalue.length;
    //         // this.isBusy = !this.isBusy;
    //       } else {
    //         this.po_typearr = [];
    //         this.totalRows = 0;
    //         // this.isBusy = !this.isBusy;
    //       }
    //     })
    //     .catch((e) => {
    //       this.errors.push(e);
    //     });
    // },

    /******Function To Get PO Type List Ends********/

    magnifyImage: function(imgID, zoom) {
      var img, glass, w, h, bw;
      img = document.getElementById(imgID);
      /*create magnifier glass:*/
      glass = document.createElement("DIV");
      glass.setAttribute("class", "img-magnifier-glass");
      glass.setAttribute("id", "magnifyingGlass");
      /*insert magnifier glass:*/
      img.parentElement.insertBefore(glass, img);
      /*set background properties for the magnifier glass:*/
      glass.style.backgroundImage = "url('" + img.src + "')";
      glass.style.backgroundRepeat = "no-repeat";
      glass.style.backgroundSize =
        img.width * zoom + "px " + img.height * zoom + "px";
      bw = 3;
      w = glass.offsetWidth / 2;
      h = glass.offsetHeight / 2;
      /*execute a function when someone moves the magnifier glass over the image:*/
      glass.addEventListener("mousemove", moveMagnifier);
      img.addEventListener("mousemove", moveMagnifier);
      /*and also for touch screens:*/
      glass.addEventListener("touchmove", moveMagnifier);
      img.addEventListener("touchmove", moveMagnifier);
      function moveMagnifier(e) {
        var pos, x, y;
        /*prevent any other actions that may occur when moving over the image*/
        e.preventDefault();
        /*get the cursor's x and y positions:*/
        pos = getCursorPos(e);
        x = pos.x;
        y = pos.y;
        /*prevent the magnifier glass from being positioned outside the image:*/
        if (x > img.width - w / zoom) {
          x = img.width - w / zoom;
        }
        if (x < w / zoom) {
          x = w / zoom;
        }
        if (y > img.height - h / zoom) {
          y = img.height - h / zoom;
        }
        if (y < h / zoom) {
          y = h / zoom;
        }
        /*set the position of the magnifier glass:*/
        glass.style.left = x - w + "px";
        glass.style.top = y - h + "px";
        /*display what the magnifier glass "sees":*/
        glass.style.backgroundPosition =
          "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
      }
      function getCursorPos(e) {
        var a,
          x = 0,
          y = 0;
        e = e || window.event;
        /*get the x and y positions of the image:*/
        a = img.getBoundingClientRect();
        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;
        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
      }
    },

    removeMagnifier: function() {
      let mg = document.getElementById("magnifyingGlass");
      if (mg) mg.remove();
    },

    showMagnifier: function() {
      let mg = document.getElementById("magnifyingGlass");
      if (mg == null) {
        this.magnifyImage("map", 4);
      } else {
        this.removeMagnifier();
      }
    },

    zoomin: function() {
      this.removeMagnifier();
      var myImg = document.getElementById("map");
      var currWidth = myImg.clientWidth;
      if (currWidth >= 680) return false;
      else {
        myImg.style.width = currWidth + 100 + "px";
      }
    },
    zoomout: function() {
      this.removeMagnifier();
      var myImg = document.getElementById("map");
      var currWidth = myImg.clientWidth;
      if (currWidth <= 270) return false;
      else {
        myImg.style.width = currWidth - 100 + "px";
      }
    },
    openimagecancel: function() {
      this.openimagemodel = !this.openimagemodel;
    },

    // Function For Action on status
    updatestylestatus: function(comment, value) {
    // alert(this.status)
      // console.log("LLLLLLLLLLLLLLLLLLLLLLLLL", value);
      console.log("this.selected_Grade------------->", this.selected_Grade)

      if((this.selected_Grade == '' || this.selected_Grade == null) && this.status == 'approved')
      {
           this.$fire({
                text: "Please select grade for the style",
                type: "warning",
                timer: 30000,
              });
      }
      else{

        // document.getElementById("overlay").style.display = "block";
        var status = value;
        var comment = comment;
        var userData = localStorage.getItem("userData");
        var userInfo = JSON.parse(userData);
        var user_id = userInfo[0].user_id;
        // return false;
        // if (status != "") {
        //     const Obj = {
        //     operational_status: status,
        //     updated_by: userInfo[0].email_id,
        //     user_id: userInfo[0].user_id,
        //     style_id: this.selected_style_id,
        //     comments: comment,
        //     grade: this.selected_Grade
        //     };


        if (status != "") {
          if(this.user_type == 'Admin')
            { 
            var tempbrandobje = []
            var localbrandid = localStorage.getItem('brand_id');
            tempbrandobje.push(localbrandid)

            this.Objectdata = {
            operational_status: status,
            updated_by: userInfo[0].email_id,
            user_id: userInfo[0].user_id,
            style_id: this.selected_style_id,
            comments: comment,
            grade: this.selected_Grade,
            brand_id:tempbrandobje
            };

          }else{
            this.Objectdata = {
            operational_status: status,
            updated_by: userInfo[0].email_id,
            user_id: userInfo[0].user_id,
            style_id: this.selected_style_id,
            comments: comment,
            grade: this.selected_Grade,
            
          };
    
          }

        axios
            .post(`${CONSTANTS.API_URL}/updatestylestatus`, this.Objectdata)
            .then((response) => {
                // document.getElementById("overlay").style.display = "none";
              this.result = response.data;
              if (this.result.returnmsg == "Successful") {    
                if ((localStorage.getItem('selectedBrandId') == '' || 
                    localStorage.getItem('selectedBrandId') == null || 
                    localStorage.getItem('selectedBrandId') == undefined
                  ) || (
                    this.result.returnvalue[0].style_code == null ||
                    this.result.returnvalue[0].style_code == '' || 
                    this.result.returnvalue[0].style_code == undefined
                  )

                  )
                  
                  {

                    this.$fire({
                          text: "Status Updated Successfully",
                          type: "success",
                          timer: 30000,
                    });
                    this.showdesigndetails = !this.showdesigndetails;
                    this.selected_Grade = ''
                    this.getdesignheadstyledetails(this.pageNo);
                    
              }
              else {
                let brandName = JSON.parse(localStorage.getItem('selectedBrandId')).target.value.split('+');
              
              // let designer_name;
              // if(userInfo[0].user_type == 'Admin') {
              //   designer_name = this.designerName;
              // } 
              // designer_name = userInfo[0].full_name;
              
              const emailObj = {
                  style_code: this.result.returnvalue[0].style_code,
                  brand_name: brandName,
                  designer_name: this.designerName,
                  user_id: userInfo[0].user_id,
              }

              console.log("emailobj--------------------------->", emailObj);
              
                axios
                .post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
                .then((response) => {
                    document.getElementById("overlay").style.display = "none";
                      if(response.data.returnmsg === "Successful"){
                        if(this.status == 'approved')
                          {
                            this.$fire({
                              text: "Status Updated Successfully and email has been sent",
                              type: "success",
                              timer: 30000,
                          });

                  } else{
                    this.$fire({
                          text: "Status Updated Successfully",
                          type: "success",
                          timer: 30000,
                    });
                  }  
              this.selected_Grade = ''
              this.showdesigndetails = !this.showdesigndetails;
              this.getdesignheadstyledetails(this.pageNo);
              }
              // else{
              //     this.$fire({
              //     text: response.data.returnvalue,
              //     type: "warning",
              //     timer: 30000,
              // });
              // }
              this.showdesigndetails = false
              }).catch((e) => {
              this.errors.push(e);
              });
              // alert("Status Updated Successfully");
              // this.$fire({
              //   text: "Status Updated Successfully",
              //   type: "success",
              //   timer: 30000,
              // });
              // this.showdesigndetails = !this.showdesigndetails;
              // this.getdesignheadstyledetails(this.pageNo);
              }

              } else {
              // alert("Please Check Status");
              this.$fire({
                  text: "Please Check Status",
                  type: "warning",
                  timer: 30000,
              });
              }
            })
            .catch((e) => {
                this.errors.push(e);
            });

              }
              else {
                  this.$fire({
                  text: "Please Check Status",
                  type: "warning",
                  timer: 120000,
                  });
              }

        }
      },

 
    commentcancel: function() {
      this.showdesigndetails = !this.showdesigndetails;
      // this.isBusy = !this.isBusy;
    },

    /****** Function to design details ********/
    getdesigndetail: function() {
      document.getElementById("overlay").style.display = "block";
      this.img_path = "";
      this.isBusy = true;

      const Obj = {
        style_id: this.selected_style_id,
      };
      axios
        .post(`${CONSTANTS.API_URL}/getdesigndetail`, Obj)
        .then((response) => {
          document.getElementById("overlay").style.display = "none";
          this.result = response.data;
          if (this.result.returnmsg === "Successful") {
            this.style_details = this.result.returnvalue[0];
            this.selected_sub_catid = this.style_details.sub_catid;
            this.img_path = this.style_details.style_image;
            this.selected_color_family = this.style_details.color_family;
            this.selected_pantone_no = this.style_details.pantone_no;
            this.selected_panton_type = this.style_details.panton_type;
            this.temp_color = this.style_details.color;
            this.selected_mutlicolor = this.style_details.color.split(",")
            this.totalRows = this.result.returnvalue.length;
            this.isBusy = !this.isBusy;
            this.sizeset = this.style_details.no_of_sizeset;
            console.log(
              "########################",
              this.style_details.no_of_sizeset
            );
            this.temp_style_description = this.style_details.style_description;
            this.temp_style_name = this.style_details.style_name;
            this.temp_style_image = this.style_details.style_image;
            this.fileObj_msg = this.result.returnvalue[1].file_name;
            this.selected_status_code_number = this.style_details.status_code_number;
            this.totalRows = this.result.returnvalue.length;
            console.log("########################", this.style_details);
            this.getselectedfamilycolor(this.selected_panton_type);
            this.setSelectedcolor(this.style_details.pantone_no, 0);
            var temp_selected_unit = this.style_details.size_details[0].unit[0];

            var temp_selected_fromage = this.style_details.size_details[0]
              .selectedfromage[0];

            var temp_selected_toage = this.style_details.size_details[0]
              .selectedtoage[0];

            console.log("^^^^^^^^^^^^^^^^^^^^^^^^", temp_selected_unit);
            // var temp_qty=this.quotationlist.size_details[0].quantity[0];
            // console.log("))))))))))))))))))))",this.quotationlist.size_details[0].quantity[0].length);
            // for( var i =0 ; i<this.style_details.size_details[0].selectedfromage[0].length;i++){
            //  this.selected_month[i]=temp_selected_unit[i];
            //  this.selectedfromage[i]=temp_selected_fromage[i];
            //  this.selectedtoage[i]= temp_selected_toage[i];

            // }

            if (
              this.style_details.status_code_number >= 12 &&
              this.style_details.status_code_number != 13
            ) {
              var temp_factorysize = this.style_details.size_details[0]
                .factorysize[0];
            }
            if (this.style_details.status_code_number >= 15) {
              var temp_qty = this.style_details.size_details[0].quantity[0];
            }

            for (
              var i = 0;
              i < this.style_details.size_details[0].selectedfromage[0].length;
              i++
            ) {
              this.tbl_selected_month[i] = temp_selected_unit[i];
              this.tbl_selectedfromage[i] = temp_selected_fromage[i];
              this.tbl_selectedtoage[i] = temp_selected_toage[i];
              if (
                this.style_details.status_code_number >= 12 &&
                this.style_details.status_code_number != 13
              ) {
                this.tbl_factorysize[i] = temp_factorysize[i];
              }
              if (this.style_details.status_code_number >= 15) {
                this.tbl_quantity[i] = temp_qty[i];
              }
            }
          } else {
            this.style_details = [];
            this.totalRows = 0;
            this.isBusy = !this.isBusy;
          }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    //Panton Color
    getcolorfamilylist: function(value) {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);

      const Obj = { color_type: "TCX" };
      axios
        .post(`${CONSTANTS.API_URL}/getcolorfamilylist`, Obj)
        .then((result) => {
          if (result.data.returnmsg === "Successful") {
            this.color_family = result.data.returnvalue;
          } else {
            this.color_family = [];
          }
        })
        .catch((ex) => {
          console.log("error", ex);
        });
    },

    getselectedfamilycolor: function(color) {
      const Obj = {
        color_family: color,
      };
      this.temp_selected_panton_type = "";
      this.temp_selected_panton_type = color;
      console.log("temp_selected_panton_type", this.temp_selected_panton_type);
      axios
        .post(`${CONSTANTS.API_URL}/getlistagainstcolorfamily`, Obj)
        .then((result) => {
          this.result1 = result.data;
          if (this.result1.returnmsg === "Successful") {
            this.color_name = this.result1.returnvalue;
            var data = [];

            this.color_name.forEach(function(srData) {
              data.push({
                key: srData.pantone_no,
                label: srData.color_name + " - " + srData.pantone_no,
              });
            });
            console.log("OOOOOOOOOOOOOOOOOOOOOO", data);
            this.color_name = data;
          } else {
            this.color_name = [];
          }
        });
    },
    setSelectedcolor: function(value, checked_val) {
      // alert("innn");
      console.log("Vallllll", value);
      console.log("checked_val", checked_val);
      // var x=document.getElementById('opt').style.backgroundColor=opt.value;
      // .style.backgroundColor=colorData;
      // document.body.style.backgroundColor =  colorData;

      // var colorData='12-6204 TCX'

      if (checked_val == 0) {
        var Obj = {
          pantone_no: value,
        };
      } else {
        var Obj = {
          pantone_no: value.key,
        };
      }
      console.log("OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO", Obj);
      axios
        .post(`${CONSTANTS.API_URL}/getlistagainstpantonno`, Obj)
        .then((result) => {
          this.pantonno_result = result.data;
          if (this.pantonno_result.returnmsg === "Successful") {
            if (this.selected_panton_type != "OTHERS") {
              this.pantoncolor = this.pantonno_result.returnvalue;
              this.showhexcolor = this.pantoncolor[0].hex_code;
              var temp_hex = this.pantoncolor[0].hex_code;
              this.showcolorname = this.pantoncolor[0].color_name;
              console.log("CCCCCCCCCCCCCCCCCCCCCCCCCC", this.showcolorname);
              var temp_colorname = this.pantoncolor[0].color_name;
              this.selected_final_color =
                this.showcolorname + " " + this.showhexcolor;
              if (checked_val == 0) {
                this.temp_selected_pantone_no = value;
              } else {
                this.temp_selected_pantone_no = value.key;
              }

              // document.getElementById("showcolor").style.backgroundColor = this.showhexcolor;
              // document.getElementById("showcolor").innerHTML = this.showcolorname + " - " + this.showhexcolor;
              // document.getElementById("showcolor1").style.backgroundColor = temp_hex;
              // document.getElementById("showcolor1").innerHTML = temp_colorname + " - " + this.showhexcolor;
              // }
            }
          } else {
            this.pantoncolor = [];
          }
        });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    opendesignModal(value) {
      this.comment = "";
      this.status = "";
      this.selected_style_id = value.style_id;

      this.customer.brand_title = value.brand_title;
      this.customer.segment_title = value.segment_title;
      this.customer.collection_title = value.collection_title;
      this.customer.style_name = value.style_name;
      this.getdesigndetail();
      this.getcolorfamilylist();
      // this.getdesigndetail();
      this.showdesigndetails = true;
    },
    //Table Set Function
    opentable: function() {
      this.opentablemodel = !this.opentablemodel;
    },
    opentablecancel: function() {
      this.opentablemodel = !this.opentablemodel;
    },

    styledropdown: function() {
      var typelisting = document.getElementById("typelist");
      if (typelisting.style.display === "block") {
        typelist.style.display = "none";
      } else {
        typelisting.style.display = "block";
      }

      // document.getElementById('typelist').style.display="none";
    },
    // opentablecancel:function(){
    //        this.opendropdownmodel=!this.opendropdownmodel;
    //    },

   getdesignheadstyledetails: function(page) {
      var storedFilters = localStorage.getItem('filters') ? JSON.parse(localStorage.getItem('filters')) : null;
      console.log("Filters      ",storedFilters);
            
      if(storedFilters){
        this.selected_po_id = storedFilters.selected_po_id ? storedFilters.selected_po_id : 0;
        this.selected_subcat_id = storedFilters.sub_catid ? storedFilters.sub_catid : 0;
        this.selected_collection_id = storedFilters.selected_collection_id ? storedFilters.selected_collection_id : 0;
        this.selected_segment_id = storedFilters.selected_segment_id ? storedFilters.selected_segment_id : 0;
      }


      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.access_token = userInfo[0]["token"];
      axios.defaults.headers.common["x-access-token"] = this.access_token;
      axios.defaults.headers.common["Content-Type"] =
        "application/json;charset=UTF-8";
      axios.defaults.headers.common["Accept"] = "application/json";
      axios.defaults.headers.common["Origin"] = "http://localhost:8080";
      // document.getElementById("overlay").style.display = "block";
      this.isBusy = !this.isBusy;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.info_length = 0;
      this.info_length = userInfo.length;
      for (var i = 1; i <= userInfo.length - 1; i++) {
        // if(userInfo[i].brand_id==this.selected_brand_id){
        this.selected_id = userInfo[i].brand_id;
        console.log("GGGGGG", this.selected_id);
        // }
      }
      this.login_user_id = userInfo[0].user_id;
      if (userInfo[0].user_type == "Admin") {
            this.Obj4 = {
            user_type: userInfo[0].user_type,
            keyword: this.route_status,
            po_id: this.selected_po_id,
            utility_id: this.selected_utility_id,
            sub_catid: this.selected_subcat_id,
            collection_id: this.selected_collection_id,
            segment_id: this.selected_segment_id,
            limit: "10",
            page_no: page,
            search_value: this.search_item,
            search_style_code: this.search_style_code,
            search_design_title: this.search_design_title,
            downloadalldata : this.downloadAllStyledata ? 'yes': 'no',

            brand_id:
            this.selected_brand_id == null
              ? this.selected_id
              : this.selected_brand_id,
            brand_type:this.selected_brand_type
        }
     
        
        axios
          .post(`${CONSTANTS.API_URL}/getfashionheadstyledetails`, this.Obj4)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;
            console.log("result", this.result);
           
            if (this.result.returnmsg === "Successful") {
              this.items = this.result.returnvalue;
              this.designerName = this.result.returnvalue[0].designer_name;
              this.style_image = this.items[0].style_image;
              this.operational_status = this.items.operational_status;
              this.styleArr = this.result.styleArr;
              this.list_totalRows = this.result.totalrecords;
              console.log("HHHHHH", this.list_totalRows);
              this.noofpages = parseInt(this.list_totalRows) / 10;

              this.noofpages = Math.ceil(this.noofpages);
              this.isBusy = !this.isBusy;
              
            } else {
              this.isBusy = false;
              this.items = [];
              this.list_totalRows = 0;
              // this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else if (
        userInfo[0].user_type == "Brand_Manager" ||
        userInfo[0].user_type == "Buyer" ||
        userInfo[0].user_type == "Buying_Head"
      ) {
             this.Obj2 = {
              user_id: this.login_user_id,
              user_type: userInfo[0].user_type,
              keyword: this.route_status,
              brand_id: userInfo[0].brand_assign,
              po_id: this.selected_po_id,
              utility_id: this.selected_utility_id,
              sub_catid: this.selected_subcat_id,
              collection_id: this.selected_collection_id,
              segment_id: this.selected_segment_id,
              limit: "10",
              page_no: page,
              search_value: this.search_item,
              search_style_code: this.search_style_code,
              search_design_title: this.search_design_title

          }
        

        axios
          .post( userInfo[0].user_type == 'Junior_Buyer' ? `${CONSTANTS.API_URL}/getDashboardListingforJuniorBuyer`:
            `${CONSTANTS.API_URL}/getdashboardlistingforbrandmangerandbuyer`,
            this.Obj2
          )
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;

            if (this.result.returnmsg === "Successful") {
              this.items = this.result.returnvalue;
              this.designerName = this.result.returnvalue[0].designer_name;
              this.style_image = this.items[0].style_image;
              this.operational_status = this.items.operational_status;
              this.styleArr = this.result.styleArr;
              this.list_totalRows = this.result.totalrecords;
              console.log("HHHHHH", this.list_totalRows);
              this.noofpages = parseInt(this.list_totalRows) / 10;

              this.noofpages = Math.ceil(this.noofpages);
              this.isBusy = !this.isBusy;
            } else {
              this.isBusy = false;
              this.items = [];
              this.list_totalRows = 0;
              // this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else if (userInfo[0].user_type == "Brand_Designer") {
        
        const Obj = {
          user_id: this.login_user_id,
          user_type: userInfo[0].user_type,
          keyword: this.route_status,
          brand_id: userInfo[0].brand_assign,
          po_id: this.selected_po_id,
          utility_id: this.selected_utility_id,
          sub_catid: this.selected_subcat_id,
          collection_id: this.selected_collection_id,
          segment_id: this.selected_segment_id,
          limit: "10",
          page_no: page,
          search_value: this.search_item,
          search_style_code: this.search_style_code,
          search_design_title: this.search_design_title,
        };

        axios
          .post(`${CONSTANTS.API_URL}/getdesignerstyledetails`, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;

            if (this.result.returnmsg === "Successful") {
              this.items = this.result.returnvalue;
              this.operational_status = this.items.operational_status;
              this.designerName = this.result.returnvalue[0].designer_name;
              this.list_totalRows = this.result.totalrecords;
              console.log("HHHHHH", this.list_totalRows);
              this.noofpages = parseInt(this.list_totalRows) / 10;

              this.noofpages = Math.ceil(this.noofpages);
              this.isBusy = !this.isBusy;
            } else {
              this.isBusy = false;
              this.items = [];
              this.list_totalRows = 0;
              // this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else if (userInfo[0].user_type == "Fit_Technician") {
        const Obj = {
          user_id: this.login_user_id,
          user_type: userInfo[0].user_type,
          keyword: this.route_status,
          brand_id: userInfo[0].brand_assign,
          po_id: this.selected_po_id,
          utility_id: this.selected_utility_id,
          sub_catid: this.selected_subcat_id,
          collection_id: this.selected_collection_id,
          segment_id: this.selected_segment_id,
          search_value: this.search_item,
          search_style_code: this.search_style_code,
          search_design_title: this.search_design_title,
          limit: "10",
          page_no: page,
          // user_id : 25
        };

        axios
          .post(`${CONSTANTS.API_URL}/getdashboardlistingforfit_tech`, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;

            if (this.result.returnmsg === "Successful") {
              this.items = this.result.returnvalue;
              this.operational_status = this.items.operational_status;
              this.designerName = this.result.returnvalue[0].designer_name;
              // this.list_totalRows = this.result.returnvalue.length;
              this.list_totalRows = this.result.totalrecords;
              console.log("HHHHHH", this.list_totalRows);
              this.noofpages = parseInt(this.list_totalRows) / 10;

              this.noofpages = Math.ceil(this.noofpages);
              this.isBusy = !this.isBusy;
            } else {
              this.isBusy = false;
              this.items = [];
              this.list_totalRows = 0;
              // this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else if (userInfo[0].user_type == "Quality_Controller") {
        const Obj = {
          user_id: this.login_user_id,
          user_type: userInfo[0].user_type,
          // keyword: this.$route.params.id,
          keyword: this.route_status,
          brand_id: userInfo[0].brand_assign,
          po_id: this.search_po,
          utility_id: this.search_utility,
          sub_catid: this.search_subcat,
          search_value: this.search_item,
          // user_id : 25
        };

        axios
          .post(
            `${CONSTANTS.API_URL}/getdashboardlistingforqualitycontrol`,
            Obj
          )
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;

            if (this.result.returnmsg === "Successful") {
              this.items = this.result.returnvalue;
              this.operational_status = this.items.operational_status;
              this.designerName = this.result.returnvalue[0].designer_name;
              this.list_totalRows = this.result.returnvalue.length;
              this.isBusy = !this.isBusy;
            } else {
              this.isBusy = false;
              this.items = [];
              this.list_totalRows = 0;
              // this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else if (userInfo[0].user_type == "Quality_Executive") {
        const Obj = {
          user_id: this.login_user_id,
          user_type: userInfo[0].user_type,
          // keyword: this.$route.params.id,
          keyword: this.route_status,
          brand_id: userInfo[0].brand_assign,
          po_id: this.search_po,
          utility_id: this.search_utility,
          sub_catid: this.search_subcat,
          search_value: this.search_item,
          // user_id : 25
        };

        axios
          .post(`${CONSTANTS.API_URL}/getdashboardlistingforQC_Executive`, Obj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;

            if (this.result.returnmsg === "Successful") {
              this.items = this.result.returnvalue;
              this.operational_status = this.items.operational_status;
              this.designerName = this.result.returnvalue[0].designer_name;
              this.list_totalRows = this.result.returnvalue.length;
              this.isBusy = !this.isBusy;
            } else {
              this.isBusy = false;
              this.items = [];
              this.list_totalRows = 0;
              // this.isBusy = !this.isBusy;
            }
          })
          .catch((e) => {
            this.errors.push(e);
          });
      } else {

             this.Obj3 = {
              user_id: this.login_user_id,
              user_type: userInfo[0].user_type,
              brand_manager: userInfo[0].brand_manager,
              keyword: this.route_status,
              brand_id: userInfo[0].brand_assign,
              po_id: this.selected_po_id,
              utility_id: this.selected_utility_id,
              sub_catid: this.selected_subcat_id,
              collection_id: this.selected_collection_id,
              segment_id: this.selected_segment_id,
              limit: "10",
              page_no: page,
              search_value: this.search_item,
              search_style_code: this.search_style_code,
              search_design_title: this.search_design_title,
              downloadalldata : this.downloadAllStyledata ? 'yes': 'no'

          }


        // var userData = localStorage.getItem('userData');
        // var userInfo = JSON.parse(userData)
        // const Obj = {
        //   user_id: this.login_user_id,
        //   user_type: userInfo[0].user_type,
        //   // keyword: this.$route.params.id,
        //   keyword: this.route_status,
        //   brand_id: userInfo[0].brand_assign,
        //   brand_manager: userInfo[0].brand_manager,
        //   po_id: this.search_po,
        //   utility_id: this.search_utility,
        //   sub_catid: this.search_subcat,
        //   limit: "10",
        //   page_no: page,
        //   search_value: this.search_item,
        //   // user_id : 25
        // };

        axios
          .post(userInfo[0].user_type == 'Junior_Buyer' ? `${CONSTANTS.API_URL}/getDashboardListingforJuniorBuyer`: `${CONSTANTS.API_URL}/getdesignheadstyledetails`, this.Obj3)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;

            if (this.result.returnmsg === "Successful") {
              this.items = this.result.returnvalue;
              this.dataitem = this.result.returnvalue;
              this.designerName = this.result.returnvalue[0].designer_name;
              // this.list_totalRows = this.result.returnvalue.length;
              this.list_totalRows = this.result.totalrecords;
              console.log("HHHHHH", this.list_totalRows);
              this.noofpages = parseInt(this.list_totalRows) / 10;
              
              this.noofpages = Math.ceil(this.noofpages);
              this.isBusy = !this.isBusy;
              
            } else {
              this.isBusy = false;
              this.items = [];
              this.list_totalRows = 0;
              // this.isBusy = !this.isBusy;
            }
            // this.downloadAllStyledata = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
      }
    },


    async getdesignheadstyledetailsforbulkdownload(page) {
      var storedFilters = localStorage.getItem('filters') ? JSON.parse(localStorage.getItem('filters')) : null;
      console.log("Filters      ", storedFilters);

      if (storedFilters) {
      this.selected_po_id = storedFilters.selected_po_id ? storedFilters.selected_po_id : 0;
      this.selected_subcat_id = storedFilters.sub_catid ? storedFilters.sub_catid : 0;
      this.selected_collection_id = storedFilters.selected_collection_id ? storedFilters.selected_collection_id : 0;
      this.selected_segment_id = storedFilters.selected_segment_id ? storedFilters.selected_segment_id : 0;
      }

      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);
      this.access_token = userInfo[0]["token"];
      axios.defaults.headers.common["x-access-token"] = this.access_token;
      axios.defaults.headers.common["Content-Type"] =
      "application/json;charset=UTF-8";
      axios.defaults.headers.common["Accept"] = "application/json";
      axios.defaults.headers.common["Origin"] = "http://localhost:8080";
      // document.getElementById("overlay").style.display = "block";
      // Don't toggle isBusy for bulk download, it affects the table display
      // this.isBusy = !this.isBusy;
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.info_length = 0;
      this.info_length = userInfo.length;
      for (var i = 1; i <= userInfo.length - 1; i++) {
      // if(userInfo[i].brand_id==this.selected_brand_id){
      this.selected_id = userInfo[i].brand_id;
      console.log("GGGGGG", this.selected_id);
      // }
      }
      this.login_user_id = userInfo[0].user_id;
      try {
      if (userInfo[0].user_type == "Admin") {
        this.Obj4 = {
        user_type: userInfo[0].user_type,
        keyword: this.route_status,
        po_id: this.selected_po_id,
        utility_id: this.selected_utility_id,
        sub_catid: this.selected_subcat_id,
        collection_id: this.selected_collection_id,
        segment_id: this.selected_segment_id,
        limit: "10",
        page_no: page,
        search_value: this.search_item,
        downloadalldata : this.downloadAllStyledata ? 'yes': 'no',
        brand_id:
          this.selected_brand_id == null
          ? this.selected_id
          : this.selected_brand_id,
        brand_type: this.selected_brand_type
        };

        const response = await axios.post(`${CONSTANTS.API_URL}/getfashionheadstyledetails`, this.Obj4);
        // Don't hide overlay here, let the download function control it
        // document.getElementById("overlay").style.display = "none";
        this.result = response.data;
        console.log("result", this.result);

        if (this.result.returnmsg === "Successful") {
        this.dataitem = this.result.returnvalue;
        } else {
        this.dataitem = [];
        }
      } else if (userInfo[0].user_type == "Brand_Manager") {
        this.Obj2 = {
        user_id: this.login_user_id,
        user_type: userInfo[0].user_type,
        keyword: this.route_status,
        brand_id: userInfo[0].brand_assign,
        po_id: this.selected_po_id,
        utility_id: this.selected_utility_id,
        sub_catid: this.selected_subcat_id,
        collection_id: this.selected_collection_id,
        segment_id: this.selected_segment_id,
        limit: "10",
        page_no: page,
        search_value: this.search_item,
        downloadAll: this.downloadAllStyledata == true ? 'yes' : 'no'
        };

        const response = await axios.post(`${CONSTANTS.API_URL}/getdashboardlistingforbrandmangerandbuyer`, this.Obj2);
        // Don't hide overlay here, let the download function control it
        // document.getElementById("overlay").style.display = "none";
        this.result = response.data;

        if (this.result.returnmsg === "Successful") {
        this.dataitem = this.result.returnvalue;
        } else {
        this.dataitem = [];
        }
      } else {
        this.Obj3 = {
        user_id: this.login_user_id,
        user_type: userInfo[0].user_type,
        brand_manager: userInfo[0].brand_manager,
        keyword: this.route_status,
        brand_id: userInfo[0].brand_assign,
        po_id: this.selected_po_id,
        utility_id: this.selected_utility_id,
        sub_catid: this.selected_subcat_id,
        collection_id: this.selected_collection_id,
        segment_id: this.selected_segment_id,
        limit: "10",
        page_no: page,
        search_value: this.search_item,
        downloadalldata: this.downloadAllStyledata == true ? 'yes' : 'no'
        };

        const response = await axios.post(`${CONSTANTS.API_URL}/getdesignheadstyledetails`, this.Obj3);
        // Don't hide overlay here, let the download function control it
        // document.getElementById("overlay").style.display = "none";
        this.result = response.data;

        if (this.result.returnmsg === "Successful") {
        // this.items = this.result.returnvalue;
       
          this.dataitem = this.result.returnvalue;
    
        } else {
        this.dataitem = [];
        }
        // this.downloadAllStyledata = false;
      }
      } catch (e) {
      this.errors.push(e);
      }
    },

    // logic start for multiple approve/reject

    setSelectedDesign: function(checked, value) {
      if (checked) {
        this.selectedDesign.push(value);
      } else {
        let tempList = this.selectedDesign.filter((item) => item !== value);
        this.selectedDesign = tempList;
      }
    },

    handleAlterCheckComponent: function(checked,value){
      console.log('check all value------------------->',this.checkAll,document.getElementById('checkAll').checked)
      this.checkAll = false;
      document.getElementById('checkAll').checked = false
      if (checked) {
        this.selectedDesign.push(value);
      } else {
        let tempList = this.selectedDesign.filter((item) => item !== value);
        this.selectedDesign = tempList;
      }
    },

    isDesignSelected: function(value) {
      return this.selectedDesign.includes(value);
    },

    allDesignSeleted: function(checked) {
      // alert(checked)
      this.selectedDesign = [];
      this.isAllDesignSelected = checked;
      // alert(this.isAllDesignSelected)
      if (this.isAllDesignSelected) {
        for (let item of this.items) {
          this.selectedDesign.push(item.style_id);
        }
      } else {
        this.selectedDesign = [];
      }

      this.getStyleIdList();

    },

    getStyleIdList(){
      document.getElementById("overlay").style.display = "block";
        if(this.isAllDesignSelected == true){

        var userData = localStorage.getItem("userData");
        var userInfo = JSON.parse(userData);
        // console.log("userInfo",userInfo)
        var tempbrandobje = []
        
        if(this.user_type == 'Admin')
        { 
          var localbrandid = localStorage.getItem('brand_id');
          tempbrandobje.push(localbrandid)

        }else{
          tempbrandobje.push(userInfo[0].brand_assign)
  
        }

        console.log("tempbrandobje", tempbrandobje)

        this.Object1 ={ 
              user_id: this.login_user_id,
              user_type: userInfo[0].user_type,
              brand_manager: userInfo[0].brand_manager,
              keyword: this.route_status,
              brand_id: tempbrandobje,
              po_id: this.search_po,
              utility_id: this.search_utility,
              sub_catid: this.search_subcat,
              search_value: this.search_item,
              downloadalldata : 'no',
                }
        }
        

         axios
          .post(`${CONSTANTS.API_URL}/getStyleIdList`, this.Object1)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            this.result = response.data;

            if (this.result.returnmsg === "Successful") {
                this.styleArr = this.result.returnvalue;
              
            }else{
               this.$fire({
                text: "Something went wrong, Please try again!",
                type: "error",
                timer: 30000,
              });
             
            }
          })
      

    },

    approveDesign: function(action) {
      document.getElementById("overlay").style.display = "block";
      var userData = localStorage.getItem("userData");
      var userInfo = JSON.parse(userData);


      let url = CONSTANTS.API_URL + "/updateStyleStatusBulk";
      if(this.isAllDesignSelected == true)
      {
         this.body1 = {
            operational_status: action,
            style_id: this.styleArr,
            user_id: this.login_user_id,
            updated_by: this.user_email,
            user_type: this.user_type,
            isCheckAll: "True",
            grade: this.selected_Grade ? this.selected_Grade : "",
          }
      }else{
          this.body1 = {
            operational_status: action,
            style_id: this.selectedDesign,
            user_id: this.login_user_id,
            updated_by: this.user_email,
            user_type: this.user_type,
            isCheckAll: "",
          };
      }
     

      axios.defaults.headers.common["x-access-token"] = this.access_token;
      axios.defaults.headers.common["Content-Type"] =
        "application/json;charset=UTF-8";
      axios.defaults.headers.common["Accept"] = "application/json";
      axios.defaults.headers.common["Origin"] = "http://localhost:8080";

      // let designer_name;
      //         if(userInfo[0].user_type == 'Admin') {
      //           designer_name = this.designerName;
      //         } 
      // designer_name = userInfo[0].full_name;
              
      axios
        .post(url, this.body1)
        .then((res) => {
          console.log(res);

          document.getElementById("overlay").style.display = "none";
          this.result = res.data;

          if (this.result.returnmsg === "Successful") {
            if ((localStorage.getItem('selectedBrandId') == '' || 
                      localStorage.getItem('selectedBrandId') == null || 
                      localStorage.getItem('selectedBrandId') == undefined
                    ) || (
                      this.result.returnvalue[0].style_code == null ||
                      this.result.returnvalue[0].style_code == '' || 
                      this.result.returnvalue[0].style_code == undefined
                    )

                    )
                    
                    {

                      this.$fire({
                            text: "Status Updated Successfully",
                            type: "success",
                            timer: 30000,
                      });
                      this.selectedDesign = [];
                      this.selectedDesign.length = 0;
                      this.isAllDesignSelected = false;
                      this.getdesignheadstyledetails();
                      this.checkAll = false;
                      document.getElementById('checkAll').checked = false
                      
            }
           
            else {
            let brandName = JSON.parse(localStorage.getItem('selectedBrandId')).target.value.split('+');
            // let designer_name;
            //   if(userInfo[0].user_type == 'Admin') {
            //     designer_name = this.designerName;
            //   } 
            //   designer_name = this.designerName;
              const emailObj = {
                style_code: this.result.returnvalue[0].style_code,
                brand_name: brandName,
                designer_name: this.designerName,
                 user_id: userInfo[0].user_id,
              }

              console.log("emailobj--------------------------->", emailObj);
              
        axios
          .post(`${CONSTANTS.API_URL}/addEmailTriggersDesignIsApproved`, emailObj)
          .then((response) => {
            document.getElementById("overlay").style.display = "none";
            if (response.data.returnmsg === "Successful") {
              this.$fire({
                text: "Status Updated Successfully and email has been sent for approval",
                type: "success",
                timer: 30000,
              });
            }
            else {
              this.$fire({
                text: response.data.returnvalue,
                type: "danger",
                timer: 30000,
              });
            }
          })  
            
            this.selectedDesign = [];
            this.selectedDesign.length = 0;
            this.isAllDesignSelected = false;
            this.getdesignheadstyledetails();
            this.checkAll = false;
            document.getElementById('checkAll').checked = false

            }
            
          } else {
            this.$fire({
              text: "Please Check Status",
              type: "warning",
              timer: 30000,
            });
            this.isAllDesignSelected = false;
            this.getdesignheadstyledetails();
            this.checkAll = false;
            document.getElementById('checkAll').checked = false
          }
        })
        .catch((err) => {
          console.log(err);
          document.getElementById("overlay").style.display = "none";
          this.errors.push(err);
          this.$fire({
            text: "Error while updating status!",
            type: "warning",
            timer: 30000,
          });
        });
    },

    // logic end for multiple approve/reject

    // assign style to junior buyer
    assignStyle(styleId, styleCode){
      console.log("@@@@@@@@@@@@@@@@@@@@@@@@@")
      this.selected_styleid = styleId
      this.selected_styleCode = styleCode
      this.showAssignStyleModal =! this.showAssignStyleModal
      this.getBuyerList();
    },

    getBuyerList(){
       var userData = localStorage.getItem("userData");
       var userInfo = JSON.parse(userData);

      document.getElementById("overlay").style.display = "block";
      const obj={

        user_id: userInfo[0].user_id,
        user_type: userInfo[0].user_type ,
        brand_id: userInfo[0].brand_assign,
      }

      axios.post(`${CONSTANTS.API_URL}/getBuyerList`, obj)
      .then((response) => {
        document.getElementById("overlay").style.display = "none";
         if (response.data.returnmsg === "Successful") {
          console.log(response.data.returnvalue)
          this.buyer_list_arr = response.data.returnvalue;
         }
      })      


    },

    validatesubmitAssignForm(scope){
      var userData = localStorage.getItem("userData");
       var userInfo = JSON.parse(userData);
      document.getElementById("overlay").style.display = "block";
       this.$validator.validateAll(scope).then((result) => {
        if (result) {
          const obj={
            style_id: this.selected_styleid ,
            buyer_id: this.buyername,
            updated_by: userInfo[0].email_id
          }
          console.log(obj)

          axios.post(`${CONSTANTS.API_URL}/assignStyleToJuniorBuyer`, obj)
          .then((response)=>{
            document.getElementById("overlay").style.display = "none";
            if(response.data.returnmsg === 'Successful'){
               this.$fire({
                text: "Style assigned successfully",
                type: "success",
                timer: 30000,
              });
              this.buyername = '',
               this.showAssignStyleModal = false;
               this.getdesignheadstyledetails();

            }else{
               this.$fire({
                text: response.data.returnvalue,
                type: "error",
                timer: 30000,
              });
              this.buyername = '',
               this.showAssignStyleModal = false;
               this.getdesignheadstyledetails();
            }
          })
        }
      });

    },

    cloaseAssignStyleModal(){
      this.buyername = '',
      this.showAssignStyleModal = false;
    },

    selectGrade(){
        this.showGradeModal = true;
    },

    bulkapproveselectgrade(){
      this.showGradeModalbulkapprove = true;
      
      // this.approveDesign('approved')
    },
    // selectedbulkapproved
    // selected_Grade

    validategrade(){
        console.log("ddddddddddddddddddd",this.selected_Grade)
        this.showGradeModal = false;
    },
    validategradegrade(){
        console.log("ddddddddddddddddddd",this.selected_Grade)
        
        if(this.selected_Grade == null || this.selected_Grade == ''){
          this.$fire({
            text: "Please select grade",
            type: "warning",
            timer: 30000,
          });
          return;
        }else{
          this.showGradeModalbulkapprove = false;
           this.approveDesign('approved') 
        } 
       
    },

    

    cancelshowGradeModal(){
        this.selected_Grade =  null;
        this.showGradeModal = false;
    },

  // downloadstyledata() {
  //   if (!this.items || this.items.length === 0) {
  //      this.$fire({
  //         text: "No data available to download.",
  //         type: "error",
  //         timer: 30000,
  //       });
  //     return;
  //   }

  //   // LIST OF FIELDS YOU WANT TO KEEP
  //   const keys = [
  //     "style_code",
  //     "design_title",
  //       "style_name",
  //       "brand_title",

  //       "operational_status",
  //       "design_status",
  //       "designer_name",
  //       "sub_cattitle",
  //       "color",
  //       "potype_title",
  //       "utility_title",
        
  //       "sub_category_id",
  //      ,
  //       "segment_title",
  //       "collection_title",
        
  //       "comments",
  //       "style_image",
  //       "style_image_type",
  //       "sample_image",
  //       "sub_catid"

      
  //   ];

  //   // Filter each item to keep only selected fields
  //   const filteredItems = this.items.map(item => {
  //     const obj = {};
  //     keys.forEach(k => obj[k] = item[k]);
  //     return obj;
  //   });

  //   // Convert to CSV
  //   const header = keys.join(",");
  //   const rows = filteredItems.map(obj => {
  //     return keys.map(k => {
  //       let value = obj[k] !== null && obj[k] !== undefined ? obj[k] : "";
  //       value = value.toString().replace(/"/g, '""');
  //       return `"${value}"`;
  //     }).join(",");
  //   });

  //   const csvContent = header + "\n" + rows.join("\n");

  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const url = URL.createObjectURL(blob);

  //   const a = document.createElement("a");
  //   a.href = url;
  //   a.download = "style_data.csv";
  //   a.click();

  //   URL.revokeObjectURL(url);
  // }

  downloadstyledata_old() {
  if (!this.items || this.items.length === 0) {
    alert("No data available");
    this.downloadAllStyledata = false
    return;
  }
  this.downloadAllStyledata = true
  
// downloadalldata
  // KEYS YOU WANT IN THE EXPORT
  const keys = [
    "style_code",
    "design_title",
    "style_name",
    "brand_title",
    "operational_status",
    "design_status",
    "designer_name",
    "sub_cattitle",
    "color",
    "potype_title",
    "utility_title",
    "sub_category_id",
    "segment_title",
    "collection_title",
    "comments",
    "style_image",
    "style_image_type",
    "sample_image",
    "sub_catid"
  ];

  // FILTER EACH ITEM TO KEEP ONLY THESE KEYS + 3 NEW COLUMNS
  const enhancedData = this.items.map(item => {
    const filtered = {};

    keys.forEach(k => {
      filtered[k] = item[k] !== undefined ? item[k] : "";
    });

    // Add 3 new columns
    filtered["Grade"] = "";     // dropdown
    filtered["Comment"] = "";   // free text
    filtered["Status"] = "";    // dropdown

    return filtered;
  });

  // CONVERT JSON → SHEET
  const ws = XLSX.utils.json_to_sheet(enhancedData);

  // DROPDOWN LIST DATA
  const gradeList = '"A,A+,B,B+,C,C+,D"';
  const statusList = '"Approved,Rejected,Feedback"';

  // ROWS START AT 2 (Row 1 = Headers)
  const startRow = 2;
  const endRow = enhancedData.length + 1;

  // GET COLUMN INDEXES
  const totalColumns = Object.keys(enhancedData[0]).length;

  const gradeCol = XLSX.utils.encode_col(totalColumns - 3);
  const commentCol = XLSX.utils.encode_col(totalColumns - 2);
  const statusCol = XLSX.utils.encode_col(totalColumns - 1);

  // APPLY DROPDOWN VALIDATION
  ws['!dataValidation'] = [
    {
      type: "list",
      allowBlank: true,
      sqref: `${gradeCol}${startRow}:${gradeCol}${endRow}`,
      formulas: [gradeList]
    },
    {
      type: "list",
      allowBlank: true,
      sqref: `${statusCol}${startRow}:${statusCol}${endRow}`,
      formulas: [statusList]
    }
  ];

  // CREATE WORKBOOK
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Style Data");

  // DOWNLOAD FILE
  XLSX.writeFile(wb, "style_data.xlsx");
},

// downloadstyledata() {
//   if (!this.items || this.items.length === 0) {
//     alert("No data available");
//     this.downloadAllStyledata = false
//     return;
//   }

//   this.downloadAllStyledata = true;
//   // this.getdesignheadstyledetails();

  
//   this.dataitem = this.items



 
// }


 async urlToBase64(url) {
      const res = await fetch(url);
      if (!res.ok) {
        throw new Error("Failed to load image: " + url);
      }
      const blob = await res.blob();

      return new Promise(function (resolve, reject) {
        const reader = new FileReader();
        reader.onloadend = function () {
          // reader.result: "data:image/png;base64,AAAA..."
          const result = reader.result || "";
          const parts = result.split(",");
          const base64 = parts.length > 1 ? parts[1] : "";
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },

async downloadstyledata() {
  document.getElementById("overlay").style.display = "block";

  // Helper function to wait for FileSaver to finish
  const saveFileAsync = (blob, filename) => {
    return new Promise((resolve) => {
      saveAs(blob, filename);
      setTimeout(() => resolve(), 600); // wait until download prompt opens
    });
  };

  if (!this.items || this.items.length === 0) {
    alert("No data available");
    document.getElementById("overlay").style.display = "none";
    return;
  }

  this.downloadAllStyledata = true;
  await this.getdesignheadstyledetailsforbulkdownload();

  if (this.dataitem.length <= 0) {
    this.downloadAllStyledata = false;
    document.getElementById("overlay").style.display = "none";
    return;
  }

  console.log(this.dataitem.length);

  const MAX_EMBED_IMAGES = 400;
  let embeddedImagesCount = 0;

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Style Data");

  // Define columns
  sheet.columns = [
    { header: "style_code", key: "style_code", width: 20 },
    { header: "style_id", key: "style_id", width: 20 },
    { header: "design_title", key: "design_title", width: 25 },
    { header: "style_name", key: "style_name", width: 25 },
    { header: "brand_title", key: "brand_title", width: 20 },
    { header: "operational_status", key: "operational_status", width: 20 },
    { header: "design_status", key: "design_status", width: 20 },
    { header: "designer_name", key: "designer_name", width: 25 },
    { header: "sub_cattitle", key: "sub_cattitle", width: 20 },
    { header: "color", key: "color", width: 15 },
    { header: "potype_title", key: "potype_title", width: 20 },
    { header: "utility_title", key: "utility_title", width: 20 },
    { header: "sub_category_id", key: "sub_category_id", width: 15 },
    { header: "segment_title", key: "segment_title", width: 20 },
    { header: "collection_title", key: "collection_title", width: 25 },
    { header: "comments", key: "comments", width: 30 },
    { header: "style_image", key: "style_image", width: 18 },
    { header: "style_image_type", key: "style_image_type", width: 15 },
    { header: "sample_image", key: "sample_image", width: 18 },
    { header: "sub_catid", key: "sub_catid", width: 15 },
    { header: "user_type", key: "user_type", width: 15 },
    { header: "brand_id", key: "brand_id", width: 15 },
    { header: "Grade", key: "Grade", width: 10 },
    { header: "Comment", key: "Comment", width: 30 },
    { header: "Status", key: "Status", width: 12 }
  ];

  const rowMap = [];

  for (let i = 0; i < this.dataitem.length; i++) {
    const x = this.dataitem[i];

    const row = sheet.addRow({
      style_code: x.style_code || "",
      style_id: x.style_id || "",
      design_title: x.design_title || "",
      style_name: x.style_name || "",
      brand_title: x.brand_title || "",
      operational_status: x.operational_status || "",
      design_status: x.design_status || "",
      designer_name: x.designer_name || "",
      sub_cattitle: x.sub_cattitle || "",
      color: x.color || "",
      potype_title: x.potype_title || "",
      utility_title: x.utility_title || "",
      sub_category_id: x.sub_category_id || "",
      segment_title: x.segment_title || "",
      collection_title: x.collection_title || "",
      comments: x.comments || "",
      style_image: "",
      style_image_type: x.style_image_type || "",
      sample_image: "",
      sub_catid: x.sub_catid || "",
      user_type: this.user_type || "",
      brand_id:
          this.selected_brand_id == null
          ? this.selected_id
          : this.selected_brand_id,
      Grade: "",
      Comment: "",
      Status: ""
    });

    rowMap.push({ rowNumber: row.number, x });
  }

  const lastRow = sheet.rowCount;

  // Grade + Status dropdowns
  const gradeColLetter = sheet.getColumn("Grade").letter;
  const statusColLetter = sheet.getColumn("Status").letter;

  sheet.dataValidations.add(`${gradeColLetter}2:${gradeColLetter}${lastRow}`, {
    type: "list",
    allowBlank: false,
    formulae: ['"A,A+,B,B+,C,C+,D"'],
    showErrorMessage: true,
    errorStyle: "stop",
    errorTitle: "Invalid Grade",
    error: "Select a Grade from the dropdown."
  });

  sheet.dataValidations.add(`${statusColLetter}2:${statusColLetter}${lastRow}`, {
    type: "list",
    allowBlank: false,
    formulae: ['"approved,rejected,Feedback"'],
    showErrorMessage: true,
    errorStyle: "stop",
    errorTitle: "Invalid Status",
    error: "Select approved, rejected or Feedback only."
  });

  // Insert images or hyperlinks
  const styleImgLetter = sheet.getColumn("style_image").letter;
  const sampleImgLetter = sheet.getColumn("sample_image").letter;

  for (let i = 0; i < rowMap.length; i++) {
    const rowInfo = rowMap[i];
    const rowNumber = rowInfo.rowNumber;
    const x = rowInfo.x;

    // STYLE IMAGE
    if (x.style_image) {
      const url = x.style_image;

      // Always set a hyperlink/text so the cell is never blank
      sheet.getCell(`${styleImgLetter}${rowNumber}`).value = {
        text: "Open image",
        hyperlink: url
      };

      if (embeddedImagesCount < MAX_EMBED_IMAGES) {
        try {
          const ext =
            (x.style_image_type || "").toLowerCase().includes("jpg") ||
            (x.style_image_type || "").toLowerCase().includes("jpeg")
              ? "jpeg"
              : "png";

          const base64 = await this.urlToBase64(url);

          const imgId = workbook.addImage({ base64, extension: ext });

          sheet.addImage(
            imgId,
            `${styleImgLetter}${rowNumber}:${styleImgLetter}${rowNumber}`
          );

          const row = sheet.getRow(rowNumber);
          row.height = row.height < 60 ? 60 : row.height;

          embeddedImagesCount++;
        } catch (e) {
          console.error("Failed to embed style image", e);
          // keep the hyperlink already set
        }
      }
    }

    // SAMPLE IMAGE
    if (x.sample_image) {
      const url = x.sample_image;

      // Always set a hyperlink/text so the cell is never blank
      sheet.getCell(`${sampleImgLetter}${rowNumber}`).value = {
        text: "Open image",
        hyperlink: url
      };

      if (embeddedImagesCount < MAX_EMBED_IMAGES) {
        try {
          const ext =
            (x.style_image_type || "").toLowerCase().includes("jpg") ||
            (x.style_image_type || "").toLowerCase().includes("jpeg")
              ? "jpeg"
              : "png";

          const base64 = await this.urlToBase64(url);

          const imgId = workbook.addImage({ base64, extension: ext });

          sheet.addImage(
            imgId,
            `${sampleImgLetter}${rowNumber}:${sampleImgLetter}${rowNumber}`
          );

          const row = sheet.getRow(rowNumber);
          row.height = row.height < 60 ? 60 : row.height;

          embeddedImagesCount++;
        } catch (e) {
          console.error("Failed to embed sample image", e);
          // keep the hyperlink already set
        }
      }
    }
  }

  // Generate file & wait until download prompt appears
  try {
    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    // WAIT until browser download prompt opens
    await saveFileAsync(blob, "style_data.xlsx");

    // Reset flag and hide loader after successful download
    this.downloadAllStyledata = false;
    document.getElementById("overlay").style.display = "none";

  } catch (e) {
    console.error("Error generating Excel file:", e);
    alert("Failed to generate Excel file.");
    // Reset flag and hide loader on error
    this.downloadAllStyledata = false;
    document.getElementById("overlay").style.display = "none";
  }
},


  selectFile(event) {
    // alert()
    this.selectedFiles = event.target.files[0];
    this.imgname = this.selectedFiles.name;
    console.log("selectedFiles", this.selectedFiles);
    this.updateStylesStatusFromXLS()
    
  },

  // Helper method for retrying failed uploads
  async retryUpload(data, config, maxRetries = 2) {
    let lastError;
    
    for (let i = 0; i <= maxRetries; i++) {
      try {
        if (i > 0) {
          console.log(`Retry attempt ${i} for large file upload`);
          this.$fire({
            text: `Retrying upload (attempt ${i + 1})...`,
            type: "info",
            timer: 5000,
          });
          
          // Wait a bit before retrying
          await new Promise(resolve => setTimeout(resolve, 2000));
        }
        
        const response = await axios.post(`${CONSTANTS.API_URL}/updateStylesStatusFromXLS`, data, config);
        return response;
      } catch (error) {
        lastError = error;
        console.error(`Upload attempt ${i + 1} failed:`, error);
        
        // Don't retry for certain errors
        if (error.response) {
          if ([400, 401, 403, 413, 422].includes(error.response.status)) {
            // Don't retry for client errors
            throw error;
          }
        }
        
        // Continue to next retry if not the last attempt
        if (i < maxRetries) {
          continue;
        }
      }
    }
    
    throw lastError;
  },

     async updateStylesStatusFromXLS() {

        if (!this.selectedFiles) {
          this.$fire({
            text: "Please select a file",
            type: "warning",
            timer: 30000,
          });
          return;
        }

        // Validate file type
        const fileName = this.selectedFiles.name.toLowerCase();
        if (!fileName.endsWith('.xlsx') && !fileName.endsWith('.xls')) {
          this.$fire({
            text: "Please upload a valid Excel file (.xlsx or .xls)",
            type: "error",
            timer: 30000,
          });
          return;
        }

        // Check file size (limit to 1GB for large Excel files)
        const maxSize = 1024 * 1024 * 1024; // 1GB
        if (this.selectedFiles.size > maxSize) {
          this.$fire({
            text: "File size too large. Please upload a file smaller than 1GB.",
            type: "error",
            timer: 30000,
          });
          return;
        }

        // Show warning for very large files
        if (this.selectedFiles.size > 100 * 1024 * 1024) { // > 100MB
          this.$fire({
            text: `Large file detected (${Math.round(this.selectedFiles.size / (1024 * 1024))}MB). Upload may take several minutes. Please be patient.`,
            type: "info",
            timer: 10000,
          });
        }

      document.getElementById("overlay").style.display = "block";
      
      // Debug logging for large files
      console.log('File details:', {
        name: this.selectedFiles.name,
        size: this.selectedFiles.size,
        type: this.selectedFiles.type,
        lastModified: this.selectedFiles.lastModified,
        sizeInMB: Math.round(this.selectedFiles.size / (1024 * 1024))
      });

      // Add special warning for very large files
      if (this.selectedFiles.size > 200 * 1024 * 1024) {
        console.warn('Very large file detected:', this.selectedFiles.size, 'bytes');
      }

      axios.defaults.headers.common["x-access-token"] = this.access_token;

      const data = new FormData();
      data.append("file", this.selectedFiles);
      data.append("user_id", this.user_id);
      data.append("file_name", this.imgname);

      const config = {
        responseType: "blob", //  REQUIRED
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 1800000, // 30 minutes timeout for very large files
        maxContentLength: 1024 * 1024 * 1024, // 1GB max file size
        maxBodyLength: 1024 * 1024 * 1024, // 1GB max request body
        onUploadProgress: (progressEvent) => {
          this.progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          
          // Update overlay text with progress
          const overlay = document.getElementById("overlay");
          if (overlay) {
            let progressText = overlay.querySelector('.progress-text');
            if (!progressText) {
              progressText = document.createElement('div');
              progressText.className = 'progress-text';
              progressText.style.cssText = `
                position: absolute;
                top: 60%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: white;
                font-size: 16px;
                font-weight: bold;
                text-align: center;
              `;
              overlay.appendChild(progressText);
            }
            progressText.innerHTML = `
              <div>Uploading large file (${Math.round(this.selectedFiles.size / (1024 * 1024))}MB)...</div>
              <div style="margin-top: 10px;">${this.progress}% complete</div>
              <div style="margin-top: 5px; font-size: 12px;">This may take several minutes. Please do not close this window.</div>
              <div style="width: 200px; height: 6px; background-color: rgba(255,255,255,0.3); border-radius: 3px; margin: 10px auto;">
                <div style="width: ${this.progress}%; height: 100%; background-color: #28a745; border-radius: 3px; transition: width 0.3s;"></div>
              </div>
            `;
          }
        },
      };

      try {
        const response = await this.retryUpload(data, config);

        document.getElementById("overlay").style.display = "none";
        
        // Clean up progress indicator
        const overlay = document.getElementById("overlay");
        const progressText = overlay && overlay.querySelector('.progress-text');
        if (progressText) {
          progressText.remove();
        }
        this.progress = 0;

        const contentType = response.headers["content-type"];

        //JSON Response
        if (contentType && contentType.includes("application/json")) {

          const text = await response.data.text(); // convert blob → text
          const json = JSON.parse(text);

          if (json.returnmsg === "Successful") {
            this.$fire({
              text: "Styles status updated successfully",
              type: "success",
              timer: 30000,
            });
          } else {
            // alert(json.returnmsg.returnvalue)
            this.$fire({
              text: "Please add comment, grade and status" ,
              type: "error",
              timer: 30000,
            });
          }

          this.getdesignheadstyledetails();
          this.selectedFiles = "";
          this.imgname = "";

          return;
        }

        //Excel File Download
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;

        let fileName = "Style_Status_Result.xlsx";
        const disposition = response.headers["content-disposition"];

        if (disposition) {
          const match = disposition.match(/filename="?(.+)"?/);
          if (match && match[1]) fileName = match[1];
        }

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);

        this.$fire({
          text: "Styles updated successfully",
          type: "success",
          timer: 30000,
        });

        this.getdesignheadstyledetails();
        this.selectedFiles = "";
        this.imgname = "";
        
        // Reset file input
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.value = '';
        }
      } catch (err) {
        console.error("err",err);
        document.getElementById("overlay").style.display = "none";
        
        // Clean up progress indicator
        const overlay = document.getElementById("overlay");
        const progressText = overlay && overlay.querySelector('.progress-text');
        if (progressText) {
          progressText.remove();
        }
        this.progress = 0;

        let errorMessage = json.returnmsg.returnvalue ;
        let retryMessage = "";
        
        if (err.code === 'ECONNABORTED') {
          errorMessage = "Request timed out. Large files can take 20-30 minutes to process.";
          retryMessage = " Please try again and ensure you have a stable internet connection. Do not close the browser during upload.";
        } else if (err.response) {
          if (err.response.status === 413) {
            errorMessage = "File size too large for server.";
            retryMessage = " The server cannot accept files this large. Please contact your system administrator.";
          } else if (err.response.status === 500) {
            errorMessage = "Server error occurred while processing the large file.";
            retryMessage = " Please try again later or contact support if the issue persists.";
          } else if (err.response.status === 400) {
            errorMessage = "Invalid file format or corrupted file.";
            retryMessage = " Please check your file and try again. Large files may get corrupted during transfer.";
          } else if (err.response.status === 422) {
            errorMessage = "File processing error - the file may be too large or complex.";
            retryMessage = " Please verify your file format and data, then try again.";
          } else if (err.response.status === 502 || err.response.status === 504) {
            errorMessage = "Gateway timeout - the server is taking too long to process your large file.";
            retryMessage = " Please try again later when server load is lower.";
          }
        } else if (err.request) {
          errorMessage = "No response from server for large file upload.";
          retryMessage = " Please check your internet connection and ensure it's stable for large file transfers.";
        }

        this.$fire({
          text: errorMessage + retryMessage,
          type: "warning",
          timer: 30000,
        });

         this.getdesignheadstyledetails();
            this.selectedFiles = "";
            this.imgname = "";
            
            // Reset file input
            const fileInput = document.querySelector('input[type="file"]');
            if (fileInput) {
              fileInput.value = '';
            }
      }
    },



    async DownloadExcel() {
      document.getElementById("overlay").style.display = "block";
      try {
        let assign_sub_cat;
        let brand_id;
        var userData = localStorage.getItem("userData");
        if(userData){
          var userInfo = JSON.parse(userData);
          brand_id=userInfo[0].brand_assign;
          assign_sub_cat = userInfo[0].subcat_assign.map(subcat=>{
            return subcat.sub_catid;
          });
        }
        console.log("assign_sub_cat",this.selected_subcat_id)
        const payload = {
         brand_id: brand_id || this.selected_brand_id || "",
         sub_catid: this.selected_subcat_id ||assign_sub_cat,
        };
        console.log("DownloadExcel payload:", payload);

        const url = `${CONSTANTS.API_URL}/generateProtoTrcUpdatedExcel`;

        // ensure access token
        if (!this.access_token) {
          const ud = localStorage.getItem("userData");
          if (ud) this.access_token = JSON.parse(ud)[0]["token"];
        }
        axios.defaults.headers.common["x-access-token"] = this.access_token;

        // request binary data
        const response = await axios.post(url, payload, {
          responseType: "arraybuffer",
        });

        const contentType = (response.headers && response.headers["content-type"]) || "";

        // If server returned JSON (error), decode and show message
        if (contentType.includes("application/json")) {
          const txt = new TextDecoder().decode(response.data);
          let json = null;
          try {
            json = JSON.parse(txt);
          } catch (e) {
            json = { returnvalue: txt };
          }
          this.$fire({ text: json.returnvalue || "Error from server", type: "error", timer: 30000 });
          return;
        }

        // create blob and download
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // try to read filename from headers
        let filename = "PO_Form_Template.xlsx";
        const disposition = response.headers["content-disposition"] || response.headers["Content-Disposition"] || "";
        const fnMatch = disposition.match(/filename\*=UTF-8''(.+)|filename="?([^\"]+)"?/);
        if (fnMatch) {
          filename = decodeURIComponent(fnMatch[1] || fnMatch[2]);
        }

        saveAs(blob, filename);
      } catch (err) {
        console.error("DownloadExcel error:", err);
        this.$fire({ text: "Failed to download Excel", type: "error", timer: 30000 });
      } finally {
        document.getElementById("overlay").style.display = "none";
      }
    },
   

     async readExcelHeader(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[firstSheetName];

          // Get first row as an array of headers
          const header = XLSX.utils.sheet_to_json(sheet, {
            header: 1, // return rows as arrays
            range: 0,  // start from first row
          })[0] || [];

          // Normalize: trim and toString
          const normalized = header.map(h =>
            h === null || h === undefined ? "" : h.toString().trim()
          );

          resolve(normalized);
        } catch (err) {
          reject(err);
        }
      };

      reader.onerror = (err) => reject(err);
      reader.readAsArrayBuffer(file);
    });
  },

  compareHeaders(actual, expected) {
    const missing = expected.filter(h => !actual.includes(h));
    const extra   = actual.filter(h => h && !expected.includes(h));
    return { missing, extra, ok: missing.length === 0 };
  },

    handleUploadFileChange(event) {
    this.uploadFile = event.target.files[0];
    },


  async uploadSelectedFile() {
    if (!this.uploadFile) {
      this.$fire({
        text: "Please select a file to upload",
        type: "warning",
        timer: 30000,
      });
      return;
    }

    const CSVHEADERS = [
      "Style ID",
      "Photo Reshoot",
      "Open MRP",
      "Base Cost","Brand Name","Story Name","Category Name",
      "Style Grading","Sub Category Name",
      "HSN Code (Dubai)","8 Digit HSN Code (Dubai)",
      "Packaging","Made In","No. of Units in a Pack",
      "Gender","Size Chart Template","Season Code",
      "Length","CHARACTER","SHOW STOPPER","Breadth",
      "Height","Top Fabric/Upper Fabric","Size","Bottom Fabric/Sole Material","Waist","PO Type","Silhouette/Shape","Highlight","Pattern/Print Type",
      "Pattern Length","Fabric Type","Surface Ornamentation",
      "Sleeve Length","Utility",
      "Neckline","Neck Opening","BACK","Fabric Composition",
      "Material","Default Footwear Size","Fastening Type","Size","Tax","Export Only","SHOW STOPPER","Case Size",
      "Inner Lining","Footwear Last Code","12 Digit HSN Code (KSA)","India B2D","India HSN","Primary FC Color","FC Color 2","FC Color 3","FC Color 4","EPP","Is Only B2B Active","Key Differentiator","Important Instruction for PH Content","Saber Registered","Brand Size","Only For UAE","Vendor ID","Buyer ID","BRAND ID"
    ];

    const file = this.uploadFile;
    const name = file.name.toLowerCase();

    const isExcel = name.endsWith(".xlsx") || name.endsWith(".xls");
    if (!isExcel) {
      this.$fire({
        text: "Please upload an Excel file (.xlsx or .xls).",
        type: "warning",
        timer: 30000,
      });
      return;
    }

    try {
      const actualHeaders = await this.readExcelHeader(file);
      // console.log("Actual Excel headers:", actualHeaders);
      const { missing, extra, ok } = this.compareHeaders(actualHeaders, CSVHEADERS);

      if (!ok && missing.length) {
        this.$fire({
          text: "Some expected columns are missing: " + missing.join(", "),
          type: "warning",
          timer: 30000,
        });
      }

      document.getElementById("overlay").style.display = "block";

      const userData = localStorage.getItem("userData");
      const userInfo = userData ? JSON.parse(userData) : null;
      const user_id = userInfo ? userInfo[0].user_id : null;
      const email_id= userInfo ? userInfo[0].email_id : null;
      const formData = new FormData();
      formData.append("file", file);
      if (user_id) formData.append("user_id", user_id);
      if (email_id) formData.append("email_id", email_id);
      axios.defaults.headers.common["x-access-token"] = this.access_token;
      axios.defaults.headers.common["Accept"] = "application/json";

      const url = `${CONSTANTS.API_URL}/uploadPOsheet`;

      let resp;
      try {
        resp = await axios.post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } catch (e) {
        console.error("uploadPOsheet HTTP error:", e.response || e);
        this.$fire({
          text: "Server error while uploading file",
          type: "error",
          timer: 30000,
        });
        return;
      }


      if (resp.data.returnmsg === "Successful") {
        this.$fire({
          text: resp.data.message || "File uploaded successfully",
          type: "success",
          timer: 30000,
        });

        const s3 = (resp.data && resp.data.s3_downloads) || {};
        const openUrlDownload = (url, name) => {
          if (!url) return;
          // Prefer opening in a new tab so user can save (S3 may not set Content-Disposition)
          const a = document.createElement("a");
          a.href = url;
          a.target = "_blank";
          a.rel = "noopener";
          // attempt to set filename if browser honors it
          a.download = name || "";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };

        openUrlDownload(s3.original_excel, "PO_Original.xlsx");
        openUrlDownload(s3.invalid_excel_full, "PO_Invalid.xlsx");
        openUrlDownload(s3.inserted_excel_full, "PO_Inserted.xlsx");

        this.uploadFile = null;
        this.$bvModal.hide("upload-po-sheet-modal");
      } else {
        this.$fire({
          text: resp.data.returnvalue || "Error while uploading file",
          type: "error",
          timer: 30000,
        });
       this.uploadFile = null;
       this.$bvModal.hide("upload-po-sheet-modal");

      }
    } catch (err) {
      console.error("uploadSelectedFile error:", err);
      this.$fire({
        text: "Error while reading or uploading the file",
        type: "error",
        timer: 30000,
      });
    } finally {
      document.getElementById("overlay").style.display = "none";
    }
  },

  // inside methods
  onUploadModalHidden() {
    this.uploadFile = null;
  },
    async validateFileHeaders(file) {
      const REQUIRED_HEADERS = [
        "style_code",
        "style_id",
        "design_title",
        "style_name",
        "brand_title",
        "operational_status",
        "design_status",
        "designer_name",
        "sub_cattitle",
        "color",
        "potype_title",
        "utility_title",
        "sub_category_id",
        "segment_title",
        "collection_title",
        "comments",
        "style_image",
        "style_image_type",
        "sample_image",
        "sub_catid",
        "user_type",
        "brand_id",
        "Grade",
        "Comment",
        "Status"
      ];

      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Get first row (headers)
            const headers = XLSX.utils.sheet_to_json(worksheet, {
              header: 1,
              range: 0,
            })[0];

            if (!headers || !headers.length) {
              reject("File has no headers");
              return;
            }

            // Normalize headers (trim + lowercase)
            const uploadedHeaders = headers.map(h =>
              String(h).trim().toLowerCase()
            );

            const requiredHeaders = REQUIRED_HEADERS.map(h =>
              h.toLowerCase()
            );

            const missingHeaders = requiredHeaders.filter(
              h => !uploadedHeaders.includes(h)
            );

            if (missingHeaders.length > 0) {
              reject(
                `Missing headers: ${missingHeaders.join(", ")}`
              );
            } else {
              resolve(true);
            }
          } catch (err) {
            console.error("validateFileHeaders error:", err);
            reject("Invalid Excel/CSV file");
          }
        };

        reader.readAsArrayBuffer(file);
      });
    }

  }
};
</script>
<style>
.img-magnifier-container {
  position: relative;
}

.img-magnifier-glass {
  position: absolute;
  border: 3px solid #000;
  border-radius: 50%;
  cursor: none;
  /*Set the size of the magnifier glass:*/
  width: 200px;
  height: 200px;
}

.account-settings__content > * {
  flex-grow: 1;
}

.profile-settings {
  flex-grow: 1;
  padding: 20px 24px;
}

.profile-settings > h1 {
  font-weight: 600;
  padding: 0;
  margin: 0;
}
.profile-settings .content {
  display: flex;
}
.profile-settings .content .profile-fields-container {
  max-width: 356px;
  margin-right: 56px;
}
.profile-settings .tabular-fields {
  font-size: 14px;
  line-height: 20px;
  flex-direction: column;
}
.profile-settings .tabular-fields .field-row {
  margin-top: 20px;
  min-height: 44px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.profile-settings .tabular-fields .field-row > .field-label {
  color: var(--fill-grey-medium);
  min-width: 100px;
  margin: 12px 0;
}
.profile-settings .tabular-fields .field-row > .field-value {
  margin-left: 32px;
  flex-grow: 1;
}

.design-container-details__main {
  background-color: white;
  border-left: 1px solid #d4d4d4;
}

.profile-settings .content .img.img-invalid {
  background-color: #6f4ce6;
}
.profile-settings .content .img {
  max-width: 100%;
  position: relative;
  height: 175px;
  width: 175px;
  border-radius: 4px;
  overflow: hidden;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  border: 1px solid var(--fill-grey-light2);
  padding: 5px;
}

/*****CSS For Zoom Image*****/
*body {
  margin: 0;
}
#btn_navbar {
  overflow: hidden;
  text-align: center;
  /*position: fixed;*/
  top: 0;
  width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 20px;
}
#btn_navbar a {
  float: left;
  display: block;
  color: #666;
  text-align: center;
  padding-right: 20px;
  text-decoration: none;
  font-size: 17px;
}
#btn_navbar a:hover {
  background-color: #ddd;
  color: black;
}
#btn_navbar a.active {
  background-color: #4caf50;
  color: white;
}
.main1 {
  padding: 16px;
  margin-top: 30px;
}
.main1 img {
  max-width: 100%;
  height: auto;
}
.button {
  width: 300px;
  height: 60px;
}

.detailimgborder {
  width: 300px;
  float: left;
  border: 1px solid lightgray;
}
.detailsmodalimg {
  height: 150px;
  width: 250px;
  padding: 5px;
}
.summaryzoombtn {
  padding: 5px;
  margin-left: 30%;
  margin-bottom: 10px;
}
@media screen and (max-width: 1040px) {
  .summarytableset {
    display: none;
  }
}
@media screen and (min-width: 1040px) {
  .tablemd {
    display: none;
  }
}
@media screen and (max-width: 530px) {
  #tablesm {
    display: none;
  }
}
@media screen and (max-width: 1040px) and (min-width: 992px) {
  .summarymodel {
    flex: 0 0 50%;
    max-width: 47%;
  }
}
@media screen and (max-width: 990px) {
  .summarymodel {
    flex: 0 0 50%;
    max-width: 47%;
  }
  .designsummaryipad {
    flex: 0 0 90%;
    max-width: 100%;
  }
  .detailsmodalimg {
    height: 150px;
    width: 250px;
    padding: 5px;
  }
  .detailimgborder {
    width: 205px;
    float: left;
    border: 1px solid lightgray;
  }
  .designsummary {
    margin-top: 10px;
  }
}
@media screen and (max-width: 766px) and (min-width: 480px) {
  /*.summarymodel{
    flex: 0 0 50%;
    max-width: 47%;
}
.designsummaryipad{
   flex: 0 0 90%;
    max-width: 100%;
}*/
  .detailsmodalimg {
    height: 150px;
    width: 250px;
    padding: 5px;
  }
  .detailimgborder {
    width: 255px;
    float: left;
    border: 1px solid lightgray;
  }
  .designsummary {
    margin-top: 10px;
  }
  .designsummarycol5 {
    width: 120px;
  }
  .designsummarycol1 {
    width: 10px;
  }
}
@media screen and (max-width: 479px) and (min-width: 350px) {
  .summarymodel {
    flex: 0 0 50%;
    max-width: 20%;
  }
  .detailsmodalimg {
    height: 150px;
    width: 250px;
    padding: 5px;
  }
  .detailimgborder {
    width: 200px;
    float: left;
    border: 1px solid lightgray;
  }
  .designsummary {
    margin-top: 10px;
    padding-left: 0px;
  }
  .designsummaryipad {
    font-size: 12px;
  }
  .designsummarycol1 {
    width: 10px;
  }
  .designsummarycol5 {
    width: 115px;
  }
}
@media screen and (max-width: 349px) {
  .summarymodel {
    flex: 0 0 50%;
    max-width: 15%;
  }
  .detailsmodalimg {
    height: 150px;
    width: 250px;
    padding: 5px;
  }
  .detailimgborder {
    width: 150px;
    float: left;
    border: 1px solid lightgray;
  }
  .designsummary {
    margin-top: 10px;
    padding-left: 0px;
  }
  .designsummaryipad {
    font-size: 11px;
  }
  .summaryzoombtn {
    padding: 5px;
    margin-left: 25%;
    margin-bottom: 10px;
    font-size: 10px;
  }
  .designsummarycol1 {
    width: 10px;
  }
  .designsummarycol5 {
    width: 80px;
  }
}
@media (max-width: 450px) {
  .sumtdhset {
    font-size: 10px;
  }
  .sumtdhunit {
    font-size: 10px;
  }
  .sumtdhagefrom {
    font-size: 10px;
  }
  .sumtdhageto {
    font-size: 10px;
  }
  .sumtdhsize {
    font-size: 10px;
  }
  .sumtdhquantity {
    font-size: 10px;
  }
  .sumtdbquantity {
    width: 60px;
  }
  .sumtdbsize {
    width: 60px;
  }
  .sumtdbunit {
    padding: 0px;
    height: 33px !important;
    width: 50px;
  }
  .sumtdbfage {
    padding: 0px;
    height: 33px !important;
    width: 50px;
  }
  .sumtdbtage {
    padding: 0px;
    height: 33px !important;
    width: 50px;
  }
  .detailimgborder {
    margin-top: -26px;
  }
}
</style>
